import common from './common'
import featuresPay from './feature'

const es = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Producto/Variantes",
        serialNumber: "Número de Serie",
        noProductsFound: "No se encontraron productos",
        searchByProductSku: "Buscar por producto/SKU",
        searchSerialNumbers: "Buscar números de serie",
        transactionDetails: "Detalles de la Transacción",
        notAvailable: "N/D",
        mainWarehouse: "Almacén Principal"
    },
    new_build_banner: {
        title: 'Nueva versión:',
        is_available: 'ya está disponible',
        fallback_title: 'Hay una nueva versión de la aplicación disponible',
        desc: 'Actualiza para obtener las últimas funciones y mejoras.',
        refreshing: 'Actualizando…',
        refresh_now: 'Actualizar ahora',
        later: 'Luego',
        you_are_on: "estás en"
    },
    short: {
        finance: 'Finanzas',
        stock: 'Inventario'
    },
    onboarding: {
        welcome: '¡Bienvenido!',
        step: {
            product: {
                totalBreakdown: 'Desglose total',
                overallFulfilment: 'Cumplimiento general',
                totalShippedQty: 'Cant. total enviada',
                totalReceivedQty: 'Cant. total recibida',
                totalOrderedQty: 'Cant. total pedida',
                totalShippedOrdered: 'Total enviado / pedido',
                totalReceivedOrdered: 'Total recibido / pedido',
                viewQty: 'Ver cantidad',
                fetchingQty: 'Obteniendo detalles de cantidad...',
                noStockInfo: 'No se encontró información de stock',
                title: '65% Alcanzado',
                description: '¡Solo quedan 2 pasos para comenzar tu gran éxito!',
                Warehouse: "Almacén",
            },
            stock: {
                title: '95% Casi Listo!!',
                description: 'Solo un paso más para comenzar tu gran éxito. Termínalo ahora.'
            }
        },
        business: {
            title: '¡Negocio creado con éxito!',
            description: '¡Genial! Tu negocio ha sido registrado'
        },
        product: {
            title: 'Agrega tu primer producto',
            description: 'Agrega un producto para comenzar a registrar inventario',
            Warehouse: "Almacén",
        },
        stock: {
            title: 'Intenta agregar inventario',
            description: 'Comienza a registrar el inventario entrante y saliente'
        },
        action: {
            add_business: {
                title: 'Crear Negocio',
                description: '¿Quieres crear un nuevo negocio? Haz clic aquí'
            },
            join_business: {
                title: 'Unirse a un Negocio',
                description: '¿Tienes un código de invitación? Únete aquí'
            }
        }
    },
    business: {
        title: 'Selecciona un negocio, crea uno nuevo o únete',
        add_business: {
            title: 'Crear nuevo negocio',
            name: 'Nombre del negocio',
            name_placeholder: 'Ingresa el nombre',
            category: 'Categoría del negocio',
            category_placeholder: 'Selecciona la categoría',
            button: 'Crear negocio'
        },
        edit_business: {
            title: 'Editar negocio'
        },
        join_business: {
            title: 'Unirse a un negocio',
            input_code: 'Ingresa el código de invitación a continuación:',
            field_placeholder: 'Código de invitación',
            confirm_title: 'Unirse',
            confirm_text: 'Te convertirás en parte del equipo en '
        },
        no_business: 'No hay negocios disponibles',
        create_or_join: 'Crear o unirse a un negocio',
        message: {
            saved: '¡Negocio guardado con éxito!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transacciones de stock negativo',
            isNegativeTransactionDisabledHint: 'Al activar esto, puedes evitar transacciones que resulten en stock negativo.',
            negativeStockError: 'Las transacciones de stock negativo están deshabilitadas'
        }
    },
    profile: {
        edit_profile: {
            title: 'Editar perfil',
            name: 'Nombre completo',
            name_placeholder: 'Ingresa el nombre completo',
            email: 'Correo electrónico',
            phone_number: 'Número de teléfono'
        },
        message: {
            required_name: 'El nombre es obligatorio'
        }
    },
    product: {
        weightedAverageCost: 'Costo Promedio Ponderado',
        weightedAverageValueLabel: 'Valor Promedio Ponderado',
        Product: 'Produkt',
        hideZeroStock: 'Nullbestand ausblenden',
        allVariants: 'Alle Varianten',
        choose_product: 'Elegir producto',
        choose_product_empty: 'Selecciona un producto e ingresa la cantidad',
        search: {
            placeholder: 'Buscar por nombre',
            tooltip: 'Abrir escáner',
            Warehouse: "Almacén",
        },
        column: {
            invoice: "Factura",
            image: 'Foto',
            name: 'Nombre',
            price: 'Precio',
            buying_price: 'Precio de costo',
            selling_price: 'Precio de venta',
            sku: 'SKU',
            stock: 'Stock',
            quantity: 'Cantidad',
            latest_stock: 'Restante',
            product_deleted: 'El producto ha sido eliminado',
            info_not_found: 'Información no disponible',
            expired_date: 'Fecha de expiración'
        },
        no_product: 'No hay productos disponibles',
        no_product_subtitle: 'Agrega tu primer producto para comenzar a realizar un seguimiento del inventario, los precios y las ventas.',
        create_first_product: 'Crear tu primer producto',
        add_product: {
            sku: 'Código del producto',
            sku_placeholder: 'Código del producto. Ejemplo: 12345',
            name: 'Nombre del producto',
            name_placeholder: 'Ingresa el nombre del producto',
            initial_stock: 'Stock inicial',
            initial_stock_placeholder: 'Ingresa el stock inicial',
            buying_price: 'Precio de costo',
            buying_price_placeholder: 'Ingresa el precio de costo',
            selling_price: 'Precio de venta',
            selling_price_placeholder: 'Ingresa el precio de venta',
            category: 'Categoría',
            category_placeholder: 'Seleccionar categoría',
            add_selling_price: 'Agregar precio al por mayor',
            expired_date: 'Fecha de expiración',
            expired_date_placeholder: 'Seleccionar fecha',
            description: 'Descripción',
            description_placeholder: 'Ingresa la descripción',
            Warehouse: "Almacén",
        },
        choose_selling_price: 'Elegir precio de venta',
        selling_price: 'Precio de venta',
        total_product: 'Total de productos',
        total_quantity: 'Total de stock',
        total_buying_price: 'Total del precio de costo',
        total_selling_price: 'Total del precio de venta',
        message: {
            required_name: 'El nombre del producto es obligatorio',
            required_sku: 'El SKU es obligatorio',
            required_category: 'La categoría es obligatoria',
            required_quantity: 'El stock inicial es obligatorio',
            invalid_input_qty: 'Cantidad de stock inválida',
            required_buying_price: 'El precio de costo es obligatorio',
            required_selling_price: 'El precio de venta es obligatorio',
            required_selling_price_name: 'El nombre del precio de venta es obligatorio',
            required_selling_price_price: 'El precio de venta es obligatorio'
        },
        viewMore: 'Ver más',
        WarehouseDetails: 'Detalles del almacén',
        WarehouseName: 'Nombre del almacén',
        AddWarehouse: 'Agregar almacén',
        WarehouseQty: 'Cantidad de almacén',
        Warehouse: 'Almacén',
        Warehouses: 'Almacenes',
        Variants: 'Variantes',
        VariantName: 'Nombre de variante',
        productVariant: 'Variantes de producto',
        AddVariant: 'Agregar variantes',
        TranferItem: 'Transferir artículos',
        AddUnit: 'Nueva unidad',
        InitialStkWarehouse: 'Stock inicial requerido para agregar variantes',
        InitialStockinwarehouse: 'Stock inicial en almacén',
        TotalQuantity: 'Cantidad total:',
        AddNote: 'Agregar nota (precio de costo)',
        AddNotetitle: 'Agregar nota',
        VariantSuccessMessage: 'Variante del producto actualizada con éxito',
        Next: 'Siguiente',
        Submit: 'Enviar',
        INACTIVE: 'INACTIVO',
        errorone: '¡Vaya! La cantidad solicitada para',
        errortwo: 'no coincide con las cantidades asignadas del almacén. Ajuste la cantidad o reabastezca.',
        SelectWarehouse: 'Seleccionar Almacén',
        SelectVariant: 'Seleccionar Variante',
        Discount: 'Descuento',
        DiscountDetails: 'Detalles del descuento',
        FinalPrice: 'Precio final',
        DiscountType: 'Tipo de descuento',
        DiscountPer: 'Descuento %',
        DiscountValue: 'Valor del descuento',
        Discountonprice: 'Descuento en el precio',
        Discountondiscount: 'Descuento sobre descuento',
        AdditionalDiscount: 'Descuento adicional',
        SellingPrice: 'Precio de venta:',
        Save: 'Guardar',
        OnOriginalPrice: 'Sobre el precio original',
        OnDiscountedPrice: 'Sobre el precio con descuento',
        columnSelector: {
            title: 'Mostrar columnas',
            columnsButton: 'Columnas',
            costPrice: 'Precio de costo',
            sellingPrice: 'Precio de venta',
            sku: 'SKU',
            warehouse: 'Almacén',
            categories: 'Categorías',
            safetyStock: 'Stock de seguridad',
            attributes: 'Atributos',
            notes: 'Notas',
            description: 'Descripción',
            more: 'más',
            attribute: 'Atributo',
            attributesTitle: 'Atributos',
            categoriesTitle: 'Categorías',
            skuAliases: 'Alias de SKU'
        }
    },
    note: {
        title: 'Notas',
        add: 'Agregar Nota',
        no_note: 'No hay notas disponibles'
    },
    settings: {
        category: 'Categoría',
        language: 'Idioma',
        switch_business: 'Cambiar Negocio',
        currencySelect: 'Moneda',
        languageChangeSuccess: "Moneda actualizada correctamente",
        languageChangeErrorMessage: "Algo salió mal al actualizar la moneda",
        currencyAdded: "Moneda agregada correctamente",
        currencyDelete: "Moneda eliminada correctamente",
        Selectyourpreferredlanguage: "Selecciona tu idioma preferido",
    },
    category: {
        category_list: {
            title: 'Categorías de Productos'
        },
        add_category: {
            button: 'Nueva Categoría',
            title: 'Agregar Nueva Categoría'
        },
        edit_category: {
            title: 'Editar Categoría'
        },
        name: 'Nombre de la Categoría',
        name_placeholder: 'Ingrese el Nombre de la Categoría',
        no_category: 'No hay categorías disponibles'
    },
    staff: {
        add: 'Agregar Personal',
        edit: 'Editar Personal',
        access: {
            stock: 'Inventario',
            add_product: 'Agregar nuevo producto',
            edit_product: 'Editar producto',
            delete_product: 'Eliminar producto',
            view_capital_price: 'Ver Precio de Costo',
            add_category: 'Agregar nueva categoría',
            edit_category: 'Editar categoría',
            delete_category: 'Eliminar categoría',
            add_supplier: 'Agregar nuevo proveedor',
            edit_supplier: 'Editar proveedor',
            delete_supplier: 'Eliminar proveedor',
            add_customer: 'Agregar nuevo cliente',
            edit_customer: 'Editar cliente',
            delete_customer: 'Eliminar cliente',
            add_staff: 'Agregar personal',
            edit_staff: 'Editar personal',
            delete_staff: 'Eliminar personal',
            change_business_profile: 'Cambiar perfil de negocio',
            access_by_product_category: 'Acceso por categoría de producto',
            no_category_message: 'No tienes ninguna categoría añadida. Por favor, añade una categoría.',
            expenses: 'Gastos',
            view_expenses: 'Ver gastos',
            add_expenses: 'Agregar gastos',
            edit_expenses: 'Editar gastos',
            delete_expenses: 'Eliminar gastos',
            warehouse: 'Almacén',
            add_new_warehouse: 'Agregar nuevo almacén',
            edit_warehouse: 'Editar almacén',
            delete_warehouse: 'Eliminar almacén',
            transfer_warehouse: 'Transferir almacén',
            transfer_warehouse_approval: 'Aprobación de transferencia de almacén',
            access_by_warehouse: 'Acceso por almacén',
            no_warehouse_message: 'No tienes ningún almacén añadido. Por favor agrega una lista de almacenes.',
            purchase_order: "Orden de compra",
            purchase_order_creation: "Creación de orden de compra",
            purchase_order_edit: "Edición de orden de compra",
            purchase_order_cancel: "Cancelar orden de compra",
            purchase_order_reopen: "Reabrir orden de compra",
            purchase_order_receive: "Recepción de orden de compra",
            sales_order: "Orden de venta",
            sales_order_creation: "Creación de orden de venta",
            sales_order_edit: "Edición de orden de venta",
            sales_order_cancel: "Cancelar orden de venta",
            sales_order_reopen: "Reabrir orden de venta",
            sales_order_receive: "Orden de venta enviada",
            purchase_order_approval: "Aprobación de orden de compra",
            sales_order_approval: "Aprobación de orden de venta",
            can_do_available_warehouse: "Almacén disponible",
            add_batch: "Aprobación de creación de lote"
            ,
            notification: 'Notificación',
            staffNotification: 'Habilitar notificación',
            assignee: "Asignado",
        },
        no_staff: 'No hay personal disponible.'
    },
    code: {
        title: '¡Nuevo Personal Agregado!',
        subtitle: 'Comparte el código de invitación a continuación para unirte:',
        valid: 'Código válido solo por 48 horas',
        share: 'Compartir en WhatsApp',
        copied: '¡Copiado!',
        invalid: '¡Código inválido!'
    },
    history: {
        no_history: 'No hay historial.',
        detail: {
            remove: 'Eliminar Historial',
            confirm: 'Esta función afectará el inventario existente, el historial y los informes.'
        },
        no_history_selected: "No se ha seleccionado ningún historial",
        select_history_hint: "Haz clic en un historial de la lista para ver los detalles",
        select_from_left: "Selecciona desde el panel izquierdo",
    },
    supplier: {
        add: {
            title: 'Agregar Proveedor'
        },
        edit: {
            title: 'Editar Proveedor'
        },
        new: 'Nuevo proveedor',
        no_supplier: 'No hay proveedores disponibles.',
        bank: {
            title: 'Detalles Bancarios'
        },
        note: 'Notas',
        form: {
            name: {
                label: 'Nombre del Proveedor',
                placeholder: 'Ingrese el Nombre del Proveedor',
                placheolder_not_mandatory: 'Ingrese el nombre ',
                error: {
                    required: 'El nombre no puede estar vacío'
                }
            },
            contact: {
                label: 'Número de Contacto',
                placeholder: '91934554432',
                error: {
                    required: 'El número de contacto no puede estar vacío',
                    invalid: 'Número inválido. Debe incluir el código de país'
                }
            },
            bank_name: {
                label: 'Nombre del Banco',
                placeholder: 'Ingrese el Nombre del Banco'
            },
            bank_account_name: {
                label: 'Nombre del Titular de la Cuenta',
                placeholder: 'Ingrese el Nombre del Titular de la Cuenta'
            },
            bank_account_number: {
                label: 'Número de Cuenta',
                placeholder: 'Ingrese el Número de Cuenta'
            },
            note: {
                label: 'Notas',
                placeholder: 'Agregar Notas'
            },
            openingBalance: {
                addBtn: 'Agregar saldo inicial',
                label: 'Saldo inicial',
                placeholder: 'Ingresar saldo inicial',
                error: {
                    negative: 'El saldo inicial no puede ser negativo'
                }
            }
        },
        choose: 'Elegir Proveedor'
    },
    customer: {
        add: {
            title: 'Agregar Cliente'
        },
        edit: {
            title: 'Editar Cliente'
        },
        new: 'Nuevo cliente',
        no_customer: 'No hay clientes disponibles.',
        note: 'Notas',
        form: {
            name: {
                label: 'Nombre del Cliente',
                placeholder: 'Ingrese el Nombre del Cliente',
                placheolder_not_mandatory: 'Ingrese el nombre ',
                error: {
                    required: 'El nombre no puede estar vacío'
                }
            },
            contact: {
                label: 'Número de Contacto',
                placeholder: '91934554432',
                error: {
                    required: 'El número de contacto no puede estar vacío',
                    invalid: 'Número inválido. Debe incluir el código de país'
                }
            },
            address: {
                label: 'Dirección',
                placeholder: 'Ingrese la Dirección'
            },
            note: {
                label: 'Notas',
                placeholder: 'Agregar Notas'
            },
            openingBalance: {
                addBtn: 'Agregar saldo inicial',
                label: 'Saldo inicial',
                placeholder: 'Ingresar saldo inicial',
                error: {
                    negative: 'El saldo inicial no puede ser negativo'
                }
            }
        },
        choose: 'Seleccionar Comprador',
        report: {
            view: 'Ver Informe de Compradores',
            title: 'Informe de Compradores',
            no_report: 'No hay informes para compradores en la fecha seleccionada.',
            column: {
                name: 'Nombre',
                total_transaction: 'Total de Transacciones',
                total_amount: 'Total de Ventas',
                total_profit: 'Total de Ganancias'
            }
        }
    },
    confirm_delete: '¿Está seguro de que desea eliminar estos datos?',
    report: {
        title: 'Informe'
    },
    accounting: {
        download_pdf_report: 'Descargar PDF',
        title: 'Contabilidad',
        view_report: 'Ver Informe Financiero',
        dashboard_title: 'Informe Financiero',
        stats: 'Estadísticas',
        accounting_report: 'Informe de contabilidad',
        filter: {
            date: {
                placeholder: 'Seleccionar Fecha',
                submit: 'Aplicar',
                cancel: 'Restablecer Filtro'
            },
            timeframe: {
                day: 'Diario',
                week: 'Semanal',
                month: 'Mensual',
                year: 'Anual'
            }
        },
        total_sales: 'Ventas Totales',
        total_purchases: 'Compras Totales',
        total_profit: 'Beneficio Total',
        total_expenses: 'Gastos Totales',
        assets_value: 'Valor Actual de Activos',
        total_current_cogs_value: 'Valor Total Actual de COGS',
        current_asset_selling_price: 'Precio de Venta del Activo Actual',
        total_selling_price: 'Precio Total de Venta',
        table: {
            date: 'Fecha',
            sales: 'Ventas',
            purchases: 'Compras',
            profit: 'Beneficio',
            expenses: 'Gastos'
        },
        no_data: 'No hay datos disponibles.'
    },
    stock_report: {
        title: 'Informe de Stock',
        view: 'Ver Informe de Stock',
        no_report: 'No hay registros de stock para la fecha o personal seleccionado.',
        allStaffPlaceHolder: 'Todo el Personal',
        column: {
            total_product: 'Tipos de Productos Actuales',
            total_product_quantity: 'Total de Productos Actuales'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Función VIP',
            description:
                'Tu período de prueba para esta función ha terminado. Apoya el desarrollo de esta aplicación local suscribiéndote.',
            button: 'Ver Planes de Suscripción'
        }
    },
    payment: {
        order: {
            title: 'Pago'
        }
    },
    imageUploadMessage: {
        uploadSize: '¡El tamaño de la imagen no debe exceder 5 MB!',
        failedMessage: 'No se pudo subir la imagen del artículo, ¡por favor intenta de nuevo!',
        successUpload: '¡La imagen se subió correctamente!',
        failedUIError: 'No se pudo eliminar la imagen, ¡por favor intenta de nuevo!',
        SuccessErrorImage: '¡La imagen ha sido eliminada con éxito!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nombre del Producto',
        categoryLabel: 'Categoría',
        BuyingPriceLabel: 'Precio de Compra',
        SellingLabel: 'Precio de Venta',
        StockLabel: 'Stock'
    },
    historyColumns: {
        Transactionlabel: 'Tipo de Transacción',
        Locallabel: 'Hora Local',
        Createdlabel: 'Creado Por',
        Vendorlabel: 'Nombre del Vendedor',
        Buyerlabel: 'Nombre del Comprador',
        SKUlabel: 'SKU',
        Productlabel: 'Nombre del Producto',
        Categorylabel: 'Categoría',
        Buyinglabel: 'Precio de Compra',
        Sellinglabel: 'Precio de Venta',
        Initiallabel: 'Stock Inicial',
        Finallabel: 'Stock Final',
        Stocklabel: 'Cambio de Stock'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nombre del Producto',
        categoryLabel: 'Categoría',
        buyingPriceLabel: 'Precio de Compra',
        sellingPriceLabel: 'Precio de Venta',
        stockInLabel: 'Stock Entrante',
        stockOutLabel: 'Stock Saliente',
        remainingStockLabel: 'Stock Restante',
        openStockLabel: 'Stock Inicial',
        weightedAverageCost: 'Costo Promedio Ponderado',
        weightedAverageCostLabel: 'Costo Promedio Ponderado',
        weightedAverageValueLabel: 'Valor Promedio Ponderado'
    },
    accountingReportColumns: {
        dateRange: 'Rango de fechas',
        reportingPeriod: 'Período de informe',
        reportGenerate: 'Generar informe',
        warehouse: 'Almacén',
        labelDate: 'Fecha',
        labelSales: 'Ventas',
        labelPurchases: 'Compras',
        labelProfit: 'Ganancia',
        labelExpenses: 'Gastos',
        reportOptions: 'Columnas del informe',
        summaryCards: 'Tarjetas de resumen',
        grandTotal: 'Gran Total',
        continued: 'cont.',
        subtotal: 'Subtotal',
        page: 'Página'
    },
    customerReportColumns: {
        labelName: 'Nombre',
        labelTotalTransaction: 'Transacción Total',
        labelTotalSales: 'Ventas Totales',
        labelTotalProfit: 'Ganancia Total'
    },
    scannerDialog: {
        finished: 'Terminado',
        reduce: 'Reducir',
        successfull: 'Exitoso',
        searching: 'Buscando...',
        title: 'Escáner activo. ¡Apúntalo al código de barras!'
    },
    historyFilter: {
        SelectBuyer: 'Seleccionar Comprador',
        SelectVendor: 'Seleccionar Vendedor'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stock Bajo a Alto',
        StockHightoLow: 'Stock Alto a Bajo',
        AlphabetAZ: 'Alfabeto A-Z',
        AlphabetZA: 'Alfabeto Z-A'
    },
    minimizeTitle: 'Escáner activo',
    security_guarantee: {
        title: 'Seguridad de Datos Garantizada'
    },
    invoice: {
        invoicePlaceholder: 'Número de factura',
        invoiceTitle: 'Factura',
        manageInvoiceAddress: 'Gestionar dirección de factura',
        selectOrManageAddresses: 'Seleccionar, editar o crear direcciones de factura personalizadas',
        useBusinessProfileAddress: 'Usar dirección del perfil empresarial',
        noCustomAddressesFound: 'No se han añadido direcciones personalizadas',
        createCustomAddressDesc: 'Añada direcciones de facturación o de sucursal personalizadas para imprimirlas en sus facturas en lugar de los datos del perfil empresarial predeterminado.',
        defaultFromBusinessProfile: 'Predeterminado del perfil empresarial',
        editInvoiceAddress: 'Editar dirección de factura',
        createNewInvoiceAddress: 'Crear nueva dirección de factura',
        logoHeaderImage: 'Logo / Imagen de encabezado',
        deleteInvoiceAddress: '¿Eliminar dirección de factura?',
        deleteAddressConfirmText: '¿Está seguro de que desea eliminar esta dirección de factura? Esta acción no se puede deshacer.'
    },
    ManageInvoiceAddress: 'Gestionar dirección de factura',
    SelectOrManageAddresses: 'Seleccionar, editar o crear direcciones de factura personalizadas',
    UseBusinessProfileAddress: 'Usar dirección del perfil empresarial',
    CreateNewAddress: 'Crear nueva dirección',
    UpdatingList: 'Actualizando lista...',
    NoCustomAddressesFound: 'No se han añadido direcciones personalizadas',
    CreateCustomAddressDesc: 'Añada direcciones de facturación o de sucursal personalizadas para imprimirlas en sus facturas en lugar de los datos del perfil empresarial predeterminado.',
    DefaultFromBusinessProfile: 'Predeterminado del perfil empresarial',
    EditInvoiceAddress: 'Editar dirección de factura',
    CreateNewInvoiceAddress: 'Crear nueva dirección de factura',
    LogoHeaderImage: 'Logo / Imagen de encabezado',
    UploadingImage: 'Subiendo imagen...',
    UploadImage: 'Subir imagen',
    BusinessName: 'Nombre del negocio',
    AddressDetails: 'Detalles de la dirección',
    PhoneNumber: 'Número de teléfono',
    EmailAddress: 'Correo electrónico',
    DeleteInvoiceAddress: '¿Eliminar dirección de factura?',
    DeleteAddressConfirmText: '¿Está seguro de que desea eliminar esta dirección de factura? Esta acción no se puede deshacer.',

    stocklowreport: {
        no_stocklowreport_one: 'No hay elementos con configuraciones de seguridad de stock.',
        no_stocklowreport_two: 'Por favor, agregue la cantidad de seguridad de stock.',
        currentStock: 'Stock actual',
        safetyStock: 'Stock de seguridad',
        pricing: 'Precios',
        costPrice: 'Precio de costo',
        sellingPrice: 'Precio de venta',
        productInfo: 'Información del producto',
        category: 'Categoría',
        description: 'Descripción',
        no_description: 'No se ha añadido ninguna descripción',
        variants: 'Variantes',
        unitsOnHand: 'unidades disponibles',
        minimumThreshold: 'umbral mínimo',
        adjust: 'Ajustar',
        all: 'Todos',
        lowStock: 'Stock bajo',
        variantsDetails: 'Detalles de las variantes',
        qty: 'Cant.',
        addSafetyStock: 'Añadir stock de seguridad',
        searchByNameSku: 'Buscar por nombre/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Stock de seguridad del almacén'
    },
    low_alert_stock: 'Ingrese la cantidad de seguridad de stock',
    lowStockAlertNotify: 'Recibirá una notificación cuando el stock esté por debajo de la cantidad establecida.',
    applyButtonStockAlert: 'Aplicar',
    cancelButtonStockAlert: 'Cancelar',
    searchProductLabel: 'Buscar producto...',
    successfullyAddedSafetyStock: 'Stock de seguridad actualizado con éxito',
    safety_Stock: 'Stock de Seguridad',
    safety_stock_placeholder: 'Ingrese Stock de Seguridad',
    lowStockDetailsInfo: {
        ProductCode: 'Código de Producto',
        SafetyStock: 'Stock de Seguridad',
        Stock: 'Inventario',
        CostPrice: 'Precio de Costo',
        SellingPrice: 'Precio de Venta',
        Category: 'Categoría',
        Description: 'Descripción',
        ExpirationDate: 'Fecha de Caducidad'
    },
    CustomLang: {
        Attribute: 'Atributo',
        AddAttribute: 'Agregar Atributo',
        EditAttribute: 'Editar Atributo',
        CustomLabePlaceholder: 'Ingrese el nombre del atributo',
        CustomLabePlaceholderSelect: 'Seleccionar tipo',
        AddMoreAttribute: 'Agregar más Atributo',
        ItemAttribute: 'Atributo del artículo',
        TableName: 'Nombre',
        TableType: 'Tipo',
        TableAction: 'Acción',
        TableDelete: 'Eliminar',
        TableEdit: 'Editar',
        deleteMessage: 'Atributo eliminado con éxito',
        editSuccessMessage: 'Atributo actualizado con éxito',
        AddSuccessMessage: 'Atributo agregado con éxito',
        AddAtt: 'Agregar',
        EditAtt: 'Editar',
        SubmitAtt: 'Enviando...'
    },
    Expenses: {
        ExpensesTitle: 'Gastos',
        AddExpenses: 'Agregar gastos',
        ExpenseCategory: 'Categoría de gastos',
        AddExpenseCategory: 'Agregar categoría de gastos',
        NoExpenseCategory: 'No hay categoría de gasto',
        SelectExpenseCategory: 'Seleccionar categoría de gastos',
        NoExpenses: 'No hay gastos',
        ExpensesSuccess: 'Gasto creado con éxito',
        ExpensesSuccessEdit: 'Gasto actualizado con éxito',
        ExpensesCategoryName: 'Nombre de la categoría de gastos',
        ExpensesSuccessDelete: 'Gasto eliminado con éxito',
        TotalSpentThisWeek: 'Total gastado esta semana',
        AddNEC: "Agregar nueva categoría de gastos",
        NC: "Nueva categoría de gastos",
        EditNEC: "Editar categoría de gastos"
    },
    Manufacturing: {
        ProducedProduct: "Producto producido",
        QuantityManufactured: "Cantidad fabricada",
        UnitCost: "Costo unitario",
        RawMaterialsTotal: "Total de materias primas",
        TotalManufacturingCost: "Costo total de fabricación",
        NoRawMaterialsConsumed: "No se consumieron materias primas.",
        CostBreakdown: "Desglose de costos",
        GeneratedBatch: "Lote generado",
        StoredBinLocation: "Ubicación de almacenamiento",
        NoManufacturingTransactionsFound: "No se encontraron transacciones de fabricación",
        AddManufacture: 'Agregar detalles de fabricación',
        Manufacturing: 'Fabricación',
        RawMaterials: 'Materias primas',
        AdditonCosts: 'Costos adicionales',
        RawMaterial: 'Materia prima',
        AdditonCost: 'Costo adicional',
        TotalCost: 'Costo total',
        AddRawMaterial: 'Agregar materia prima para',
        AddAdditonCost: 'Agregar costo adicional para',
        AddMore: 'Agregar más',
        Add: 'Agregar',
        Update: 'Actualizar',
        Updating: 'Enviando...',
        ProductRequired: 'El producto es obligatorio',
        QuantityRequired: 'La cantidad es obligatoria',
        ChargeRequired: 'El cargo es obligatorio',
        EstimatedCostRequired: 'El costo estimado es obligatorio',
        PurchasePriceRequired: 'El precio de compra es obligatorio',
        SelectCharge: 'Seleccionar cargo',
        EstimatedCost: 'Costo estimado',
        SelectProduct: 'Seleccionar un producto',
        Quantity: 'Cantidad',
        ManufactureDetails: 'Detalles de fabricación',
        BuyingPrice: 'Precio de compra',
        LabourCharge: 'Costo de mano de obra',
        ElectricityCost: 'Costo de electricidad',
        PackagingCharge: 'Costo de empaque',
        LogisticCost: 'Costo logístico',
        OtherCharges: 'Otros cargos',
        Save: 'Guardar detalles',
        PurchasePrice: 'Precio de compra',
        Date: 'Fecha',
        For: 'Para',
        PurchaseRate: 'Tasa de compra (Precio)',
        Scrolltoloadmore: 'Desplázate para cargar más...',
        Noproductsfound: 'No se encontraron productos',
        ManufacturingQuantity: 'Cantidad de fabricación',
        ManufactureAddedSuccess: 'Detalles de fabricación actualizados con éxito'
    },
    Warehouses: {
        transferOrder: 'Transferir artículos',
        AddTransferOrder: 'Agregar artículos a la transferencia',
        NewWarehouse: 'Nuevo almacén',
        newHead: '¡Empieza a gestionar múltiples almacenes!',
        headTwo: 'Realiza un seguimiento y gestiona tu inventario sin problemas en múltiples almacenes',
        EnableWarehouse: 'HABILITAR ALMACÉN',
        EnableWarehouse2: 'Habilitar almacén',
        OrganizationPrimary: 'Principal de la organización',
        Edit: 'Editar',
        AreEnableWarehouse: '¿Estás seguro de que quieres habilitar el almacén?',
        Confirm: 'Confirmar',
        Cancel: 'Cancelar',
        WarehouseCreatedSuccessfully: 'Almacén creado con éxito',
        MarkAsOP: 'Marcar como principal de la organización',
        MarkAsInAct: 'Marcar como inactivo',
        MarkAsAct: 'Marcar como activo',
        MarkedAsInactive: 'Almacén marcado como inactivo con éxito',
        MarkedAsActive: 'Almacén marcado como activo con éxito',
        MarkedAsOP: 'Almacén marcado como principal de la organización con éxito',
        WareDeletedSuccess: 'Almacén eliminado con éxito',
        SuccessfullyUpdatedWarehouse: 'Almacén actualizado con éxito',
        SuccessfullyCreatedWarehouse: 'Almacén creado con éxito',
        EditWarehouse: 'Editar almacén',
        AddWarehouse: 'Agregar almacén',
        WarehouseNameIsRequired: 'El nombre del almacén es obligatorio',
        EnterWarehouseName: 'Ingresa el nombre del almacén',
        EnterEmail: 'Ingresa el correo electrónico',
        EnterPhoneNumber: 'Ingresa el número de teléfono',
        Location: 'Ubicación...',
        name: 'Nombre del almacén',
        email: 'Correo electrónico',
        phoneNumber: 'Número de teléfono',
        location: 'Ubicación',
        ViewProducts: 'Ver productos',
        PageTitle: 'Almacén',
        noWarehouse: "Ningún almacén coincide con tu búsqueda"
    },
    Assets: {
        headerTitle: 'Activos',
        addAssetMessage: 'Agrega activos aquí. Para asignar un activo a un empleado, ve al perfil del empleado.',
        addAsset: 'Agregar Activo',
        editAsset: 'Editar Activo',
        assetCode: 'Código del Activo',
        assetName: 'Nombre del Activo',
        assetCategory: 'Categoría del Activo',
        assetType: 'Tipo de Activo',
        serialNumber: 'Número de Serie',
        location: 'Ubicación',
        condition: 'Condición',
        selectCondition: 'Seleccionar Condición',
        fair: 'Regular',
        good: 'Bueno',
        excellent: 'Excelente',
        poor: 'Pobre',
        notes: 'Notas',
        submit: 'Enviar',
        submitting: 'Enviando',
        noCategory: 'Sin categoría',
        selectCategory: 'Seleccionar categoría',
        addAssetCat: 'Agregar Categoría de Activo',
        addAssetCatName: 'Nombre de la categoría de activo',
        edit: 'Editar',
        status: 'Estado',
        createdAt: 'Creado el',
        viewAsset: 'Ver Activo',
        assignAsset: 'Asignar Activo',
        conditionRet: 'Condición (al devolver)',
        searchSelectAssets: 'Buscar/Seleccionar Activo',
        assetAssigned: 'Activo asignado con éxito',
        assetReturned: 'Activo devuelto con éxito',
        selectAnAsset: 'Por favor, selecciona un activo',
        action: 'Acción',
        noAssetAssigned: 'No hay activos asignados',
        reAssigned: 'Reasignar',
        assignedAssetsList: 'Lista de Activos Asignados',
        viewHistory: "Ver historial",
        history: "Historial de activos",
        loadingHistory: "Cargando historial...",
        loadingMore: "Cargando más...",
        dateTime: "Fecha y hora",
        staff: "Personal",
        AssignedBy: "Asignado por",
        assign: "ASIGNAR",
        return: "DEVOLVER",
        unknown: "DESCONOCIDO",
        noHistory: "No hay historial disponible para este activo.",
        enterReturnNote: "Ingrese una nota para la devolución",
        returnNote: "Nota de devolución",
        enterAssignNote: "Ingrese una nota para la asignación",
        assignNote: "Nota de asignación",
        AddNAC: "Agregar nueva categoría de activos",
        EditNAC: "Editar categoría de activos",
        others: "Otros"
    },
    LedgerTransaction: {
        ledgerDetails: 'Detalles del Libro Mayor',
        productName: 'Nombre del Producto',
        totalQty: 'Cantidad Total',
        date: 'Fecha',
        receivedAmt: 'Monto Recibido',
        paid: 'Pagado',
        discount: 'Descuento',
        balance: 'Saldo',
        more: 'más',
        total: 'Total',
        ledgerupdatedsuccessfully: 'Libro mayor actualizado con éxito',
        ledgeraddedsuccessfully: 'Libro mayor añadido con éxito',
        viewLedger: 'Ver Libro Mayor',
        edit: 'Editar',
        create: 'Crear',
        Recieved: 'Recibido [entrada de stock]',
        payMode: 'Modo de Pago',
        Refno: 'Nº de Referencia'
    },
    ExtraField: {
        attachment: "Adjunto",
        acceptOnlyImg: "Solo aceptar imágenes.",
        addAttribute: "Agregar atributo",
        acceptImgAndDoc: "Aceptar imágenes y documentos."
    },
    phoneInvoiceDownload: {
        Variant: "Variante",
        Warehouse: "Almacén",
        Bin: "Ubicación",
        Batch: "Lote",
        Attributes: "Atributos"
    },
    ImportExcel: {
        ImportStockfromExcel: "Importar Stock desde Excel",
        DragDrop: "Arrastra y suelta tu archivo Excel aquí o haz clic para buscar",
        DT: "Descargar Plantilla",
        GB: "Volver",
        Downloading: "Descargando...",
        ChangeFile: "Cambiar Archivo",
        ReadingExcelfile: "Leyendo archivo Excel...",
        Processing: "Procesando...",
        submitUpdateStock: "Enviar y Actualizar Stock",
        downloadLatestTemplate: "Descargar Plantilla Más Reciente",
        loginRequired: "Inicio de Sesión Requerido"
    },
    stockForm: {
        recordPaymentNow: "Registrar el pago ahora",
        recordPaymentDescCustomer: "Introduce lo que pagó el cliente",
        recordPaymentDescSupplier: "Introduce lo que pagó el proveedor",
        managePayments: "Gestionar pagos",
        invoice: "Factura",
        challan: "Guía",
        recordPayment: "Registrar pago",
        payableAmount: "Monto a pagar",
        paidAmount: "Monto pagado",
        paymentMethod: "Método de pago",
        paymentDate: "Fecha de pago",
        reference: "Referencia",
        billId: "Número de factura",
        importExcel: "Importar desde Excel",
        noThanks: "No, gracias",
        checkHistory: "Ver historial",
        wantViewHistory: "¿Desea ver su historial?",
        enterPayable: "Ingrese el monto a pagar",
        enterPaid: "Ingrese el monto pagado",
        selectPayment: "Seleccione método de pago",
        attachment: "Adjunto",
        note: "Nota"
    },
    HistoryEdit: {
        products: "Productos",
        add_product: "Agregar producto",
        paidAmountInvalidMessage: "El monto pagado no puede ser mayor que el monto a pagar",
        removingText: "Eliminar este producto revertirá los cambios de stock realizados en esta transacción.",
        remove: "Eliminar"
    },
    ExcelProduct: {
        uploadFile: "Subir archivo",
        dragDrop: "Arrastra y suelta tu archivo de Excel o haz clic para subirlo.",
        parsingFile: "Analizando archivo",
        fileSelected: "Archivo seleccionado",
        reviewImportedData: "Revisa los datos importados a continuación. Las columnas se asignan automáticamente cuando es posible.",
        changeFile: "Cambiar archivo",
        back: "Atrás",
        invalidFileType: "Por favor sube un archivo de Excel válido (.xlsx o .xls)",
        parseExcelError: "Error al analizar Excel:",
        noData: "El archivo de Excel subido no contiene datos.",
        failedToRead: "No se pudo leer el archivo de Excel. Inténtalo de nuevo.",
        Nodata: "SIN_DATOS",
        unableToRead: "No se puede leer el archivo.",
        buyingMustNumber: "El precio de compra debe ser un número",
        sellingMustNumber: "El precio de venta debe ser un número",
        mustBeNumber: "debe ser un número",
        bulkUploadfailed: "La carga masiva falló",
        importFromExcel: "Importar desde Excel",
        generating: "Generando...",
        downloadTemplate: "Descargar plantilla",
        uploading: "Subiendo...",
        done: "Hecho",
        requiredField: "{field} es obligatorio",
        bulkUpload: "Carga masiva",
        duplicateSku: "Se encontró un SKU duplicado",
        uploadedSuccessfully: "¡Todos los productos se subieron correctamente!",
        uploadCompleteIssues: "Carga completada con problemas",
        uploaded_products: "{count} producto(s) subido(s).",
        failed_products: "{count} fallidos.",
        failed_items: "Elementos fallidos:"
    },
    Discount: {
        overallDiscount: "Descuento total",
        final: "Total final",
        balanceDue: "Saldo pendiente",
        tax: "Impuesto"
    },
    ProductForm: {
        barcodeQuantity: "Ingrese la cantidad del código de barras",
        baseUnit: "Unidad base (principal)",
        addSecondaryUnit: "¿Agregar unidad secundaria?",
        selectUnit: "Seleccionar unidad",
        subUnitDetails: "Detalles de la subunidad",
        subUnit: "Subunidad",
        selectSubUnit: "Seleccionar subunidad",
        conversionRate: "Tasa de conversión",
        exampleLogic: "Lógica del ejemplo:",
        example: "Si vende bolígrafos en cajas, configure la unidad base como Caja y agregue una subunidad (pieza) con una conversión de 50. Esto significa que 1 caja contiene 50 piezas.",
        basePrice: "Precio base"
    },
    barcode: {
        settings: 'Configuración de códigos de barras',
        labelSize: 'Tamaño de etiqueta',
        customSize: 'Tamaño personalizado...',
        widthMm: 'Ancho (mm)',
        heightMm: 'Alto (mm)',
        showPrice: 'Mostrar precio de venta en la etiqueta',
        noPrices: 'No hay precios de venta configurados para este producto.',
        preview: 'Previsualización',
        generate: 'Generar',
        label: 'etiqueta',
        singlePage: 'Página única',
        downloadOptions: 'Opciones de descarga',
        chooseLayout: 'Elija el diseño de los códigos de barras',
        allInSinglePage: 'Agregar todos los códigos de barras en una sola página.',
        allInA4Grid: 'Todo en página única',
        allInA4GridSub: 'Organiza todos los códigos de barras en una cuadrícula A4',
        onePerPage: 'Uno por página',
        onePerPageSub: 'Cada código de barras en su propia página de etiqueta'
    },

    TransferItem: {
        transferItem: "Transferir artículos",
        Date: "Fecha",
        Reason: "Motivo",
        enterReason: "Ingrese el motivo",
        Name: "Nombre",
        QuantityTransfered: "Cantidad transferida",
        SWarehouse: "Almacén origen",
        SelectSWarehouse: "Seleccionar almacén origen",
        DWarehouse: "Almacén destino",
        SelectDWarehouse: "Seleccionar almacén destino",
        CreatedBy: "Creado por",
        CreatedTime: "Hora de creación",
        UpdatedTime: "Hora de actualización",
        NoOrderFound: "No se encontraron pedidos",
        New: "Nuevo",
        WarehouseItemTransfer: "Transferencia de artículos de almacén",
        TotalTransfers: "Transferencias Totales",
        EnterReason: "Ingrese el motivo",
        ItemDetails: "Detalles del artículo",
        CurrentAvailable: "Disponibilidad actual",
        TransferQty: "Cantidad a transferir",
        SStock: "Stock origen",
        DStock: "Stock destino",
        addDescription: "Agregar descripción al artículo",
        selectVariant: "Seleccionar variante",
        addNewRow: "Agregar nueva fila",
        typeOrSelectItem: "Escribe para buscar",
        scrollToLoadMore: "Desplácese para cargar más",
        noProductsFound: "No se encontraron productos",
        selectWarehouse: "Seleccionar almacén"
    },
    Sku: {
        searchSelectProduct: "Buscar / seleccionar producto",
        searchSelectSku: "Buscar / seleccionar SKU",
        noSkuFound: "No se encontró SKU"
    },
    HistoryPage: {
        addFilter: "Agregar filtro",
        filtersActive: "Todos los filtros activos",
        noProducts: "Sin productos",
        download: "Descargar",
        recentlyUpdated: "Actualizado recientemente",
    },
    StockPage: {
        challanNumber: "Número de albarán",
        subTotal: "Total parcial",
        totalTaxes: "Totales e impuestos",
        taxInclusive: "Impuestos incluidos",
        discountedValue: "Valor con descuento",
        taxValue: "Valor del impuesto",
        totalAmount: "Importe total",
        close: "Cerrar",
        addTax: "Agregar impuesto",
        label: "Etiqueta",
        enterLabel: "Ingrese etiqueta",
        taxRate: "Tasa de impuesto",
        enterTaxRate: "Ingrese la tasa de impuesto",
        selectTaxRate: "Seleccionar tasa de impuesto",
        addNewTax: "Agregar nueva tasa de impuesto",
        discountProducts: "Valor con descuento (Productos)",
        taxProducts: "Valor del impuesto (Productos)",
        clickAddPayment: "Haga clic para agregar pago",
        paidGreaterPayable: "El monto pagado no puede ser mayor que el monto a pagar",
        vendorCompulsory: "El proveedor es obligatorio para registrar el pago",
        customerCompulsory: "Se requiere un cliente para registrar el pago",
        updateInvoiceFormat: "Actualizar formato de factura",
        updateChallanFormat: "Actualizar formato de albarán",
        addPrefix: "Agregar prefijo",
        prefix: "Prefijo"
    },
    EditHistoryPage: {
        search_by_notes: "Buscar por notas",
        alertMessage: "Este cambio solo se registra en el historial y no afecta el stock actual del producto.",
        paymentDetails: "Detalles del pago",
        units: "Unidades",
        customLabels: "Etiquetas personalizadas",
        value: "Valor",
        Order_Info: "Información del pedido",
        percentage: "Porcentaje",
        Stock_updates_on_submit: "Actualizar stock al enviar",
        Summary: "Resumen"

    },
    historyCard: {
        paid: "PAGADO",
        partiallyPaid: "PARCIALMENTE PAGADO",
        billDate: "Fecha de factura",
        productDetails: "Detalles del producto",
        paymentsHistory: "Historial de pagos",
        updatePayment: "Actualizar pago",
        discounts: "Descuentos",
        inclusive: "(inc.)",
        discountOverall: "Valor con descuento (Total)",
        dueAmount: "Monto adeudado",
        enterPaid: "Ingrese monto pagado",
        enterReference: "Ingrese referencia",
        enterNote: "Ingrese nota",
        enterInvoice: "Ingrese factura",
        enterChallan: "Ingrese albarán",
        edit: "Editado"
    },
    printInvoice: {
        billTo: "Facturar a",
        ref: "Ref. N°",
        mode: "Modo",
        date: "Fecha",
        amount: "Monto",
        totalPaid: "Total pagado"
    },
    Contact: {
        supplier_required: "Se requiere un proveedor para la entrada de stock",
        customer_required: "Se requiere un cliente para la salida de stock",
        key: "Clave",
        editHistory: "Editar historial",
        loading: "Cargando..."
    },
    AW: {
        availablewarehouse: "Almacén disponible",
        visibilityManagement: 'Gestión de la visibilidad',
        availablewarehouses: "Almacenes disponibles",
        Active: "Activo",
        LWarehouse: "Cargando almacenes...",
        NWForthisProduct: "No se encontraron almacenes para este producto.",
        of: "de",
        WarehouseAvailabilty: "Disponibilidad de almacén",
    },
    Currency: {
        searchCurrency: "Buscar monedas...",
        addCurrency: "Agregar moneda",
        addNewCurrency: "Agregar nueva moneda",
        editCurrency: "Editar moneda",
        currencySymbol: "Símbolo de moneda",
        currencyName: "Nombre de la moneda",
        enterCurrencySymbol: "Ingrese el símbolo de la moneda",
        enterCurrencyName: "Ingrese el nombre de la moneda"
    },
    NewReportLang: {
        DM: "Movimiento Diario",
        WR: "Informe de Almacén",
        PDM: "Movimiento Diario del Producto",
        TBP: "Precio Total de Compra",
        TPQ: "Cantidad Total de Producto",
        TP: "Productos Totales",
        CS: "Stock Actual",
        IV: "Valor del Inventario",
        DA: "Promedio Diario",
        TSI: "Total de Entrada de Stock",
        TSO: "Total de Salida de Stock",
        TOR: "Tasa de Rotación",
        Tv: "Valor Total",
        AST: "Seguimiento Activo de SKU",
        UT: "Unidades Rastreadas",
        SL: "Nivel de Stock",
        Value: "Valor",
        IO: "ENTRADA/SALIDA",
        T: "Rotación",
        unitsD: "Unidades/Día",
        Sort: "Ordenar",
        Sort_by: "Ordenar por",
        Units_available: "Unidades disponibles",
        Units_unavailable: "Unidades no disponibles",
        Current_assets: "Activos corrientes",
        Search: "Buscar",
        available: "Disponible",
        assigned: "Asignado",
        AYSWD: "¿Estás seguro de que quieres eliminar?",
        PTS: "Almacén transferido correctamente",
        AUS: "Activos actualizados correctamente",
        ACS: "Activos creados correctamente",
        VSP: "Ver precio de venta",
        HUS: "Historial actualizado correctamente",
    },
    ReplacementReturn: {
        selectProduct: "Por favor selecciona un producto",
        selectReplacementProduct: "Selecciona al menos un producto de reemplazo",
        validQuantity: "Por favor ingresa una cantidad de devolución válida",
        replacedSuccessfully: "Producto reemplazado exitosamente",
        returnSuccessfully: "Producto devuelto exitosamente",
        failedProcess: "Error al procesar. Intenta de nuevo.",
        return: "Devolver",
        replace: "Reemplazar",
        typeSelectProduct: "Escribe o selecciona producto...",
        returnQuantity: "Cantidad a devolver",
        enterQuantity: "Ingresa cantidad",
        replacementDate: "Fecha de reemplazo",
        returnDate: "Fecha de devolución",
        chooseCustomer: "Elige cliente",
        additionalNotes: "Agrega notas adicionales...",
        replacementProducts: "Productos de reemplazo",
        addProducts: "Agregar más productos",
        tapSelect: "Toca para seleccionar de productos disponibles",
        currently: "Actualmente",
        item: "artículo",
        items: "artículos",
        selected: "seleccionado",
        selectedItems: "Artículos seleccionados",
        hideDetails: "Ocultar más detalles",
        showDetails: "Mostrar más detalles",
        product: "producto",
        priceLevel: "Seleccionar nivel de precio",
        customPrice: "Ingresar precio personalizado",
        noReplaceHistory: "No se encontró historial de reemplazos",
        replaceReturn: "Reemplazar y Devolver",
        replaceReturnHistory: "Historial de Reemplazos y Devoluciones"
    },
    OtherComponent: {
        mfgHistoryTitle: "Historial de fabricación",
        mfgHistoryDesc: "Seguimiento de productos fabricados",
        dailyOperation: "Operaciones Diarias",
        freqUsed: "Acciones usadas frecuentemente para actualizar registros rápidamente",
        manageCategory: "Gestionar Categorías",
        organizeCaterory: "Organizar y gestionar categorías de productos, gastos y activos",
        businessRecord: "Registros Empresariales",
        organizeRecord: "Organizar y gestionar sus registros empresariales",
        trackHistory: "Seguimiento del Historial",
        completeTracking: "Historial completo para auditoría y seguimiento",
        Verifyinventorycount: "Verificar conteo de inventario",
        Exchangerates: "Tipos de cambio",
        Productiontracking: "Seguimiento de producción",
        Fixedassetregister: "Registro de activos fijos",
        Storagelocations: "Ubicaciones de almacenamiento",
        warehouseAvailability: 'Disponibilidad de productos a nivel de almacén',
        Logreviewspend: "Registrar y revisar gastos",
        Productgroupings: "Agrupaciones de productos",
        Classifyexpenditures: "Clasificar gastos",
        Assetclassification: "Clasificación de activos",
        Manageexchanges: "Gestionar cambios",
        Returnauditlog: "Registro de auditoría de devoluciones",
        Interlocationmoves: "Movimientos entre ubicaciones",
        Manageoperationscategoriesrecordsandhistory: "Gestionar operaciones, categorías, registros e historial"
    },
    no_permission_dialog: {
        title: 'Sin permiso',
        historyDescription: "No tienes permiso para ver el Historial de Transacciones. Por favor, contacta a tu administrador.",
        replacementHistoryDescription: "No tienes permiso para ver el Historial de Reemplazo y Devolución. Por favor, contacta a tu administrador.",
        transferHistoryDescription: "No tienes permiso para ver el Historial de Transferencia de Almacén. Por favor, contacta a tu administrador."
    },
    OthersHistory: {
        title: "Gestionar historial",
        transferHistory: "Gestionar historial de transferencias",
        transactionHistory: "Gestionar historial de transacciones",
        replacementHistory: "Gestionar historial de reemplazos y devoluciones"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Explora y compra los productos compartidos por la empresa.",
        description: "Explora los productos compartidos por la empresa.",
        productsAvailable: "Productos disponibles",
        noImageAvailable: "No hay imagen disponible",
        productDetails: "Detalles del producto",
        inStock: "en stock",
        availableVariants: "Variantes disponibles",
        options: "opciones",
        orders: "Pedidos"
        ,
        searchProducts: "Buscar productos...",
        noProductsFound: "No se encontraron productos",
        tryDifferentKeyword: "Intenta buscar con otra palabra clave",
        variants: "Variantes",
        stock: "Stock",
        cart: "Carrito",
        products: "Productos",
        viewCart: "Ver Carrito",
        backToProducts: "Volver a Productos",
        yourCart: "Tu Carrito",
        clear: "Limpiar",
        cartEmpty: "Tu carrito está vacío",
        cartEmptyDesc: "Explora el catálogo y agrega los productos que deseas pedir.",
        browseProducts: "Ver Productos",
        selectedItems: "Artículos Seleccionados",
        itemInCart: "artículo en el carrito",
        itemsInCart: "artículos en el carrito",
        customerDeliveryDetails: "Datos del Cliente y Entrega",
        fullName: "Nombre Completo",
        enterFullName: "Ingresa tu nombre completo",
        deliveryAddress: "Dirección de Entrega",
        addressPlaceholder: "Calle, edificio, ciudad, código postal...",
        orderNote: "Nota del Pedido (Opcional)",
        orderNotePlaceholder: "Instrucciones especiales o notas de entrega...",
        paymentMode: "Modo de Pago",
        subtotal: "Subtotal",
        items: "artículos",
        totalAmount: "Monto Total",
        orderOnWhatsApp: "Pedir por WhatsApp 📲",
        orderPlaced: "¡Pedido Realizado Exitosamente! 🎉",
        orderPlacedDesc: "Tu pedido ha sido registrado y se abrió WhatsApp para enviar los detalles.",
        continueShopping: "Continuar Comprando 🛍️",
        cartEmptyTitle: "Carrito Vacío",
        cartEmptyToast: "Agrega productos a tu carrito antes de pagar.",
        incompleteTitle: "Datos Incompletos",
        incompleteToast: "Completa todos los campos requeridos antes de realizar el pedido.",
        nameRequired: "El nombre completo es obligatorio",
        addressRequired: "La dirección de entrega es obligatoria",
        catalogUnavailable: "Catálogo No Disponible",
        catalogUnavailableDesc: "Este catálogo no está activo. Contacta al negocio para más información.",
        invalidCatalogLink: "Enlace de Catálogo Inválido 🚫",
        invalidCatalogDesc: "Esta página de catálogo carece de información requerida.",
        missing: "Faltante",
        catalogSlug: "Slug del Catálogo",
        goBackHome: "Volver al Inicio",
        inventoryManagement: "Gestión de Inventario y Facturación 🚀 Simply",
        enter: "Ingresar",
        select: "Seleccionar",
        // Catalog Order translations
        catalogOrders: 'Pedidos del catálogo',
        pending: 'Pendiente',
        converted: 'Convertido',
        cancelled: 'Cancelado',
        totalRevenue: 'Valor total',
        totalCatalogOrders: 'Total de pedidos en línea',
        convertToSalesOrder: 'Convertir a pedido de venta',
        date: 'Fecha',
        status: 'Estado',
        action: 'Acción',
        searchOrders: 'Buscar cliente o teléfono...',
        noMatchingOrders: 'No se encontraron pedidos',
        noStatusOrders: 'No se encontraron pedidos {status}',
        tryDifferentSearch: 'Intente buscar con un nombre de cliente o número de teléfono diferente.',
        noOrdersWithStatus: 'Actualmente no hay pedidos con estado {status}.',
        noOrdersYet: 'Aún no hay pedidos del catálogo',
        noOrdersDescription: 'Los pedidos realizados desde su catálogo en línea aparecerán aquí.',
        guestCustomer: 'Cliente invitado',
        item: 'Artículo',
        moreItems: '+{count} más',
        viewDetails: 'Ver detalles',
        viewSalesOrder: 'Ver pedido de venta',
        cancelOrder: 'Cancelar pedido',
        confirmCancelTitle: '¿Cancelar pedido del catálogo?',
        confirmCancelOrder: '¿Está seguro de que desea cancelar este pedido? Esta acción no se puede deshacer.',
        keepOrder: 'No, conservar pedido',
        confirmCancelAction: 'Sí, cancelar pedido',
        orderNotFound: 'Pedido del catálogo no encontrado',
        orderNotFoundDescription: 'No se pudo encontrar este pedido o es posible que no tenga permiso para verlo.',
        backToCatalogOrders: 'Volver a pedidos del catálogo',
        placedOn: 'Realizado el',
        totalItems: 'Total de artículos',
        orderedProducts: 'Productos pedidos',
        itemDetails: 'Detalles del artículo',
        quantity: 'Cant.',
        unitPrice: 'Precio unitario',
        total: 'Total',
        variant: 'Variante',
        customerInformation: 'Información del cliente',
        additionalFields: 'Campos adicionales',
        fields: 'campos',
    },
    stockNew: {
        Npay: "Noch keine Produkte hinzugefügt",
        emptydesc: "Wählen Sie ein Produkt aus Ihrem Katalog aus und geben Sie die eingehende Menge ein, um den Bestand zu erfassen.",
        tipText: "Tipp: Sie können auch eine Excel-Datei hochladen",
        OT: "Bestellsumme",
        Collapse: "Einklappen"
    },
    deleteBulk: {
        Bulkoperation: "Operación masiva",
        Applyproducts: "Aplicar acciones a varios productos",
        Bulkupload: "Carga masiva",
        ImportCSVfile: "Importar productos mediante archivo Excel o CSV",
        or: "o",
        Bulkdelete: "Eliminación masiva",
        Permanentlyallproducts: "Eliminar permanentemente todos los productos",
        IrrText: "La eliminación masiva es irreversible. Exporte una copia de seguridad primero si es necesario.",
        SeP: "Productos seleccionados",
        sP: "Seleccionar producto",
        DA: "Eliminar todo",
        DP: "Eliminar productos",
        sL: "Seleccionar todo",
        ASDE: "¿Estás seguro de que quieres eliminar todos los productos excepto",
        ASDAllP: "¿Estás seguro de que quieres eliminar todos los productos?",
        ASD: "¿Estás seguro de que quieres eliminar",
        products: "productos",
        TACBU: "Esta acción no se puede deshacer.",
        LP: "Cargando productos...",
        FM: "Cargando más...",
        NPF: "No se encontraron productos.",
        LMP: "Cargando más productos..."
    },
    NewVariantModal: {
        Definevariantsassign: "Definir variantes y asignar cantidades",
        Nothingallocated: "Nada asignado",
        Overallocated: "Sobreasignado",
        Fullyallocated: "Totalmente asignado",
        Overby: "Exceso de",
        Allvariantsneedaname: "Todas las variantes necesitan un nombre.",
        Reducequantities: "Reducir cantidades.",
        Overallocatedby: "Sobreasignado por",
        Quantitiesmustmatchthetotalavailability: "Las cantidades deben coincidir con la disponibilidad total.",
        Allocatequantitiesacrosswarehouses: "Asignar cantidades en almacenes",
        Notfullydistributed: "No distribuido completamente:",
        remaining: "restante",
        Qty: "Cant.",
        Inactive: "Inactivo",
        left: "restante"
    },
    ProductFormNew: {
        BasicInfo: "Información básica",
        ProductImage: "Imagen del producto",
        Images: "Imágenes",
        Pricing: "Precios",
        Everypriceneedsbothalabelandanamount: "Cada precio necesita una etiqueta y un monto",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Agrega una etiqueta como "Mayorista" o "Minorista" para identificar este precio',
        AddMultiplePrice: "Agregar múltiples precios",
        NoPhotosLetAiFind: "¿Sin fotos? Deja que la IA busque imágenes del producto",
        AddProductImagesTitle: "Agregar imágenes del producto",
        ChooseHowToAddPhotos: "Elige cómo deseas agregar fotos para este producto:",
        SearchWithAi: "Buscar con IA",
        SearchWithAiDesc: "Busca y selecciona automáticamente imágenes del producto usando IA",
        FilesFileExplorer: "Archivos (Explorador de archivos)",
        FilesFileExplorerDesc: "Elige imágenes directamente desde tu computadora",
        AiProductImageFinder: "Buscador de imágenes con IA",
        AiProductImageFinderDesc: "Busca y selecciona imágenes para tu producto",
        TypeProductNamePlaceholder: "Escribe el nombre del producto...",
        SearchForYourProduct: "Busca tu producto",
        SearchForYourProductHint: `Prueba con una marca o nombre de producto, ej. "Kirkland Minoxidil"`,
        ImagesSelected: "imágenes seleccionadas",
        AddSelected: "Agregar seleccionadas"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Definir un nuevo campo personalizado",
        AttributeName: "Nombre del atributo",
        DataType: "Tipo de dato",
        Noattributesfound: "No se encontraron atributos",
        ManageAttributes: "Administrar atributos",
        Editordeleteexistingattributes: "Editar o eliminar atributos existentes",
        UpdateAttribute: "Actualizar atributo",
        Saving: "Guardando..."
    },
    NewExpenses: {
        Noexpensesyet: "Aún no hay gastos",
        Addyourfirstexpensetostarttrackingyourspending: "Agrega tu primer gasto para comenzar a rastrear tus gastos.",
        TOTALEXPENSES: "GASTOS TOTALES",
        ENTRIES: "ENTRADAS",
        BYCATEGORY: "POR CATEGORÍA",
        Nocategoriestodisplay: "No hay categorías para mostrar",
        DateanfTime: "Fecha y hora"
    },
    PurchaseSales: {
        CancelOrder: "Cancelar pedido",
        ReopenOrder: "Reabrir pedido",
        Reopen: "Reabrir",
        ConfirmCancelOrder: "¿Está seguro de que desea cancelar este pedido?",
        ConfirmReopenOrder: "¿Está seguro de que desea reabrir este pedido?",
        OrderCancelledSuccessfully: "Pedido cancelado exitosamente.",
        OrderReopenedSuccessfully: "Pedido reabierto exitosamente.",
        CancelledBy: "Cancelado por",
        Cancelled: "Cancelado",
        ConvertPriceBasedOnUnitConversion: "Convertir precio según conversión de unidad",
        MarkPaymentAsPending: "Marcar el pago como pendiente",
        PendingReceivableDesc: "Importe registrado como cuenta por cobrar. Registra el pago cuando se reciba.",
        PendingPayableDesc: "Importe registrado como cuenta por pagar. Registra el pago cuando se realice.",
        SelectCustomerFirst: "Selecciona primero un cliente",
        SelectSupplierFirst: "Selecciona primero un proveedor",
        SelectItemsFirst: "Por favor seleccione al menos un artículo primero",
        PaymentMarkedPendingDesc: "El pago está marcado como pendiente. Desmarque 'Marcar el pago como pendiente' para registrar el pago ahora.",
        SelectCustomerAndItemFirst: "Por favor, seleccione un cliente y al menos un artículo primero",
        SelectSupplierAndItemFirst: "Por favor, seleccione un proveedor y al menos un artículo primero",
        SelectCustomerProductFirst: "Seleccione cliente y producto primero",
        SelectSupplierProductFirst: "Seleccione proveedor y producto primero",
        Receivables: "Cuentas por Cobrar",
        Payables: "Cuentas por Pagar",
        AccessDenied: "Acceso denegado",
        YouDonthaeP: "No tienes permiso para ver esta página. Si crees que es un error, contacta a tu administrador.",
        purchase: "Compra",
        sales: "Ventas",
        Areyousureyouwantto: "¿Estás seguro de que quieres",
        Thisactionwillupdateitsstatus: "Esta acción actualizará su estado.",
        ReasonOPtional: "Motivo (opcional)",
        Enterareasonfor: "Ingresa un motivo para",
        optionalDot: "(opcional)...",
        Reject: "Rechazar",
        ConfirmOrder: "Confirmar pedido",
        RejectOrder: "Rechazar pedido",
        Previous: "Anterior",
        First: "Primero",
        Order: "Pedido",
        Items: "Artículos",
        Memo: "Memo",
        SelectDateRange: "Seleccionar rango de fechas",
        List: "Lista",
        Board: "Tablero",
        View: "Vista",
        OrderType: "Tipo de pedido",
        SelectOrderType: "Seleccionar tipo de pedido",
        CreateSalesOrder: "Crear orden de venta",
        CreatePurchaseOrder: "Crear orden de compra",
        successfully: "exitosamente",
        ManageAttachments: "Gestionar adjuntos",
        Stockoutitemsimmediatelyaftersaving: "Sacar stock de artículos inmediatamente después de guardar.",
        Stockinitemsimmediatelyaftersavingthisorder: "Ingresar stock de artículos inmediatamente después de guardar esta orden.",
        ViewAttachments: "Ver adjuntos",
        MemoAttachments: "Memo y adjuntos",
        ReceivedDate: "Fecha de recepción",
        ShippedDate: "Fecha de envío",
        OrderDate: "Fecha del pedido",
        OrderDetails: "Detalles del pedido",
        Subtotal: "Subtotal",
        OrderSummary: "Resumen del pedido",
        AddItem: "Agregar artículo",
        NewSalesOrder: "Nueva orden de venta",
        NewPurchaseOrder: "Nueva orden de compra",
        Createandmanageyour: "Crea y gestiona tus",
        orders: "pedidos",
        Removeitem: "Eliminar artículo",
        UnitPrice: "Precio unitario",
        PurchaseOrder: "Orden de compra",
        SalesOrder: "Orden de venta",
        PurchaseInvoice: "Factura de compra",
        SalesInvoice: "Factura de venta",
        PurchaseOrdernotfound: "Orden de compra no encontrada",
        Approve: "Aprobar",
        MarkasShipped: "Marcar como enviado",
        MarkasReceived: "Marcar como recibido",
        Marking: "Marcando...",
        PartiallyShip: "Envío parcial",
        PartiallyReceive: "Recepción parcial",
        Deleting: "Eliminando...",
        Transaction: "Transacción",
        Details: "Detalles",
        Item: "Artículo",
        Received: "Recibido",
        Shipped: "Enviado",
        Ordered: "Ordenado",
        units: "unidades",
        Overalldiscount: "Descuento general",
        Transactions: "Transacciones",
        Notransactionsfound: "No se encontraron transacciones",
        OrderedQty: "Cantidad ordenada",
        Totalqty: "Cantidad total",
        StockingOut: "Sacando stock...",
        StockingIn: "Ingresando stock...",
        thiorderUpdateStuau: "¿este pedido? Esta acción actualizará su estado.",
        TransactionDetails: "Detalles de la transacción",
        Fetchingtransactiondetails: "Obteniendo detalles de la transacción...",
        Nodetailsfoundforthistransaction: "No se encontraron detalles para esta transacción.",
        TotalBreakDown: "Desglose total",
        ChangeAmount: "Monto de cambio",
        Attachments: "Adjuntos",
        PoNumber: "Nº de orden de compra",
        SoNumber: "Nº de orden de venta",
        partner: "Socio",
        EditPurchase: "Editar compra",
        EditSales: "Editar venta",
        PurchaseOrderDetails: "Detalles de orden de compra",
        SalesOrderDetails: "Detalles de orden de venta",
        OrderTypePrepaid: "Prepago",
        OrderTypeCOD: "Pago contra entrega",
        OrderTypePayLater: "Pagar más tarde",
        OrderTypePartialPayment: "Pago parcial",
        OrderTypeSubscription: "Suscripción",
        viewAvailabilty: 'Ver disponibilidad',
        NotReceived: "No recibido",
        NotShipped: "No enviado",
        PartiallyReceived: "Parcialmente recibido",
        PartiallyShipped: "Parcialmente enviado",
    },
    PriceReference: {
        HighPrice: "Precio Alto",
        LowPrice: "Precio Bajo",
        LastPrice: "Último Precio",
        LastPurchasePrice: "Último precio de compra",
        Nopricerecordsfound: "No se encontraron registros de precios",
        BuyingPriceReference: "Referencia de Precio de Compra",
        SellingPriceReference: "Referencia de Precio de Venta",
        Viewstockinpricesfortheselectedvendorandproduct: "Ver precios de entrada para el proveedor y producto seleccionado",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Ver precios de salida para el cliente y producto seleccionado"
    },
    SubscriptionLocale: {
        premiumPlan: "Plan Premium",
        heading: "Toma decisiones de negocio",
        headingHighlight: "Basadas en datos",
        subtitle: "Desbloquea todo el poder de tus análisis de negocio — sin límites, sin compromisos.",
        choosePlan: "Elige tu plan",
        monthly: "Mensual",
        annual: "Anual",
        oneTime: "Una sola vez (Mensual)",
        perMonth: "por mes",
        perYear: "por año",
        bestValue: "Mejor valor",
        continueWith: "Continuar con",
        perMonthShort: "mes",
        perYearShort: "año",
        troubleWithSubscription: "¿Problemas con la suscripción?",
        contactUs: "Contáctanos",
        paymentNotReady: "Pago no listo",
        checkoutError: "ERROR EN CHECKOUT",
        pricePreviewError: "ERROR EN VISTA PREVIA DE PRECIO",
        subNotAvailable: "Suscripción no disponible",
        subNotAvailableDesc: "Las suscripciones web no están disponibles actualmente en su país. Por favor, suscríbase a través de nuestra aplicación móvil o contáctenos directamente para obtener ayuda."
    },
    SubscriptionLocale2: {
        GoPro: "Ir a Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Toma decisiones más inteligentes respaldadas por datos reales de negocio",
        ExploreProPlans: "Explorar Planes Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Puedes tener múltiples almacenes para diferentes ubicaciones físicas",
            "Cada producto rastrea el stock por almacén de forma independiente",
            'Usa "Transferir Almacén" para mover stock entre ubicaciones'
        ],
        NoWarehousesConfigured: "No hay almacenes configurados",
        desc: "Comienza agregando tus almacenes (si tienes más de uno), luego procede a agregar productos y registrar movimientos de stock.",
        WarehouseSetupTips: "Consejos de configuración de almacén",
        Noproductselected: "Ningún producto seleccionado",
        Selectaproductfromthelefttoviewlowstockdetails: "Selecciona un producto de la izquierda para ver detalles de stock bajo.",
        Chooseaproductfromthelist: "Elige un producto de la lista",
        SelectProduct: "Seleccionar producto",
        SetQuantity: "Establecer cantidad",
        Showing: "Mostrando",
        products: "productos",
        Continue: "Continuar",
        SaveSafetyStock: "Guardar stock de seguridad",
        SafetyStockSaved: "¡Stock de seguridad guardado!",
        hasbeensetto: "se ha establecido en",
        AddAnother: "Agregar otro",
        Chooseaproduct: "Elegir un producto",
        Step: "Paso",
        of: "de",
        Setsafetyquantity: "Establecer cantidad de seguridad",
        Complete: "Completado",
        SafetyStockQuantity: "Cantidad de stock de seguridad",
        Minimumunitsdropsbelowthisnumber: "Unidades mínimas que siempre mantener en stock. Se activa una alerta cuando el stock baja de este número.",
        NewSafetyStock: "Nuevo stock de seguridad",
        SafetyNow: "Seguridad ahora",
        SettingTo: "Configurando a",
        Change: "Cambiar",
        sell: "vender",
        cost: "costo",
        BulUD: "Carga masiva/Eliminar"
    },
    SimplyLoginUI: {
        sslEncryption: "Encriptación SSL de 256 bits",
        dataPrivate: "Tus datos son 100% privados",
        worksOnDevices: "Funciona en Android e iPhone",
        realTimeSync: "Sincronización en tiempo real en todos los dispositivos",
        cloudBackup: "Copia de seguridad automática en la nube",
        availableOn: "Disponible en Web, Android e iOS",
        tagline: "Tu inventario,",
        taglineEm: "bellamente simple.",
        subtitle: "Inicia sesión para gestionar stock, rastrear ventas y mantener tu negocio en movimiento — todo en un solo lugar.",
        feature1Title: "Seguimiento de stock en tiempo real",
        feature1Desc: "Sabe exactamente qué hay en cada almacén, siempre actualizado.",
        feature2Title: "Órdenes de venta y compra",
        feature2Desc: "Crea facturas, gestiona proveedores y rastrea cada transacción.",
        feature3Title: "Reportes inteligentes",
        feature3Desc: "Reportes financieros, de stock y de movimientos diarios de un vistazo.",
        feature4Title: "Sincronización en tiempo real en todos los dispositivos",
        feature4Desc: "Los cambios en el teléfono aparecen al instante en la web — y viceversa.",
        rating1: "Calificado",
        rating2: "4.9/5",
        rating3: "por 10,000 negocios mayoristas",
        brandName: "Simply",
        greeting: "¡Hola de nuevo! 👋",
        noPasswordNeeded: "Inicia sesión para acceder a tu inventario — Android, iPhone y web, todo sincronizado.",
        badge1: "Gestión de Stock",
        badge2: "Seguimiento de Ventas",
        badge3: "Reportes",
        trustEncryptedTitle: "Encriptado",
        trustEncryptedSub: "SSL de 256 bits",
        trustPrivateTitle: "Privado",
        trustPrivateSub: "Solo tus datos",
        trustBackedTitle: "Respaldado",
        trustBackedSub: "Automático diario",
        availableOnLabel: "DISPONIBLE EN",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Todos los dispositivos se sincronizan al instante en tiempo real",
        securityNote: "100% seguro.",
        securityDesc: "Encriptación de grado bancario protege todos tus datos. Solo leemos tu nombre y correo — nada más, nunca.",
        signingIn: "Iniciando sesión…",
        termsPrefix: "Al iniciar sesión aceptas los",
        privacyPolicy: "Política de Privacidad",
        and: "y",
        termsOfService: "Términos de Servicio",
        google: "Iniciar sesión con Google"
    },
    BatchLocal: {
        BatchName: "Nombre del lote",
        EnterBatchName: "Ingrese el nombre del lote",
        EnterNotes: "Ingrese notas",
        ExpiredDate: "Fecha de caducidad",
        Selectexpireddate: "Seleccione fecha de caducidad",
        BatchStatus: "Estado del lote",
        CreatedDate: "Fecha de creación",
        Areyousureyouwanttodeletethisbatch: "¿Está seguro de que desea eliminar este lote?",
        Youhavencreatedanybatchforthisproduct: "Aún no ha creado ningún lote para este producto.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Cree su primer lote para comenzar a rastrear el stock por lote y fecha de caducidad.",
        Nobatchesyet: "Aún no hay lotes",
        Whatisbatchmanagement: "¿Qué es la gestión de lotes?",
        Howithelpsyourbusiness: "Cómo ayuda a su negocio",
        Trackbylotnumber: "Rastrear por número de lote",
        Trackbylotnumberdesc: "Agrupe el stock por lote del fabricante para saber siempre de qué lote proviene una unidad.",
        Expirydatecontrol: "Control de fecha de caducidad",
        Expirydatecontroldesc: "Reciba alertas antes de que el stock caduque. Venda primero los lotes más antiguos y reduzca el desperdicio automáticamente.",
        Fulltraceability: "Trazabilidad completa",
        Fulltraceabilitydesc: "Vea exactamente qué lote se usó en cada transacción — ideal para auditorías y retiros del mercado.",
        Supplierwisestock: "Stock por proveedor",
        Supplierwisestockdesc: "Separe el stock de diferentes proveedores incluso para el mismo producto. Compare la calidad lote por lote.",
        Createyourfirstbatchbutton: "Cree su primer lote",
        Nomatchesfound: "No se encontraron coincidencias",
        NomatchesfounddescBefore: "No pudimos encontrar ningún lote que coincida con ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Limpiar búsqueda",
        Nohistoryfoundthisbatch: "No se encontró historial para este lote",
        ComprehensiveDetails: "Detalles completos",
        History: "Historial",
        InBatch: "En el lote",
        Noproductfoundinthisbatch: "No se encontró ningún producto en este lote",
        SelectBatch: "Seleccionar lote",
        available: "disponible",
        Searchbatches: "Buscar lotes...",
        Expires: "Caduca",
        Nobatchesfound: "No se encontraron lotes",
        ManageBatches: "Gestionar lotes",
        Batchmanagement: "Gestión de lotes",
        Trackstockexpiry: "Rastrear stock por lote y caducidad",
        Turnoffbatchmanagement: "¿Desactivar la gestión de lotes?",
        Yourgsafe: "Sus datos de lotes existentes permanecen seguros.",
        Reenableanytimefrom: "Puede reactivarlo en cualquier momento desde",
        Otherstab: "pestaña Otros",
        AddBatch: "Agregar lote",
        Total: "Total",
        AssignProduct: "Asignar producto",
        EditProductAssignment: "Editar asignación de producto",
        AssignProducttoBatch: "Asignar producto al lote",
        Updateproductconfiguration: "Actualizar configuración del producto",
        Step1of2: "Paso 1 de 2",
        Step2of2: "Paso 2 de 2",
        Selectvariantwarehouse: "Seleccionar variante y almacén",
        SelectedProduct: "Producto seleccionado",
        AssignQuantity: "Asignar cantidad",
        BatchInfo: "Información del lote",
        Wecouldnthisproductidentifier: "No pudimos encontrar ningún lote asociado con este identificador de producto.",
        NoActiveBatches: "No hay lotes activos",
        Endofresults: "Fin de los resultados",
        Expiry: "Caducidad",
        BatchManagementDescription: "Rastree el stock por número de lote y fecha de vencimiento. Garantiza el orden correcto LIFO / FEFO en cada salida de stock, sin necesidad de selección manual.",
        Expiryalerts: "Alertas de vencimiento",
        Autonotifications: "Notificación automática",
        LIFOsorting: "Ordenamiento LIFO / FEFO",
        Smartstockflow: "Flujo de stock inteligente",
        Perout: "Salida de stock por lote",
        Precisiontracking: "Seguimiento preciso",
        NeedsReview: "Necesita revisión",
        Pending: "Pendiente",
        Rejected: "Rechazado",
        Approved: "Aprobado",
        WaitingForApproval: "Esperando aprobación",
        WaitingForApprovalDesc: "Tu propietario revisará y aprobará este lote pronto.",
        BatchRejected: "Lote rechazado",
        BatchRejectedDesc: "Tu propietario rechazó este lote.",
        Reason: "Razón",
        Approve: "Aprobar",
        Reject: "Rechazar",
        ConfirmApproveTitle: "Aprobar lote",
        ConfirmRejectTitle: "Rechazar lote",
        ConfirmApprovalAction: "¿Estás seguro de que quieres {action} este lote? Esta acción actualizará su estado.",
        ReasonOptional: "Razón (Opcional)",
        EnterReasonPlaceholder: "Introduce una razón para {action} (opcional)",
        Processing: "Procesando...",
        BatchActivatedSuccess: "Lote activado correctamente",
        BatchDeactivatedSuccess: "Lote desactivado correctamente",
        BatchDeletedSuccess: "Lote eliminado correctamente",
        BatchApprovedSuccess: "Lote aprobado correctamente",
        BatchRejectedSuccess: "Lote rechazado correctamente",
        SearchByBatchName: "Buscar por nombre de lote...",
        YesTurnOff: "Sí, apagar",
        KeepItOn: "Mantener encendido"
    },
    CategoryNewL: {
        TotalCategories: "Total de categorías",
        lastaddedcategory: "Última categoría añadida",
        acrossalltypes: "en todos los tipos",
        MostRecent: "Más reciente",
        YesD: "Sí, eliminar",
        AllAssociated: "Todos los productos asociados pueden verse afectados"
    },
    OverDas: {
        movestockbetweenlocations: "Mover stock",
        no_activity_yet: "Aún no hay actividad",
        no_activity_sub: "Las ventas, compras, movimientos de stock y devoluciones aparecerán aquí en tiempo real.",
        make_first_sale: "Realizar la primera venta",
        add_stock: "Agregar stock",
        all_stock_healthy: "Todos los niveles de stock están saludables",
        all_stock_healthy_sub: "Ningún artículo está bajo. Establezca umbrales mínimos en los productos para recibir alertas aquí.",
        set_stock_thresholds: "Establecer umbrales de stock",
        no_warehouses_setup: "No hay almacenes configurados",
        no_warehouses_setup_sub: "Agregue un almacén para comenzar a rastrear dónde se almacena su stock y gestionar ubicaciones.",
        add_first_warehouse: "Agregar primer almacén",
        Customer: "Clientes",
        PurchasevsSales: "Compras vs Ventas",
        Financialperformancechart: "Gráfico de rendimiento financiero",
        QuickActions: "Acciones rápidas",
        Frequentlyused: "Usadas frecuentemente",
        Addinventory: "Agregar inventario",
        Dispatchitems: "Despachar artículos",
        Addorder: "Agregar pedido",
        Newitem: "Nuevo artículo",
        Inventoryaccess: "Acceso al inventario",
        Itemsneedingreorder: "Artículos que necesitan reorden",
        Latesttransactions: "Últimas transacciones",
        Operationalsummary: "Resumen operativo",
        ViewAll: "Ver todo",
        Manage: "Gestionar",
        RecentActivity: "Actividad reciente",
        LowStockAlerts: "Alertas de stock bajo",
        Primary: "Principal",
        TotalWarehouses: "Total de almacenes"
    },
    SerialLocal: {
        ShowOrHideFields: "Mostrar u ocultar campos",
        ShowOrHideFieldsDesc: "Toca cualquier elemento a continuación para incluirlo o eliminarlo de la factura impresa. Los cambios se aplican al instante.",
        Manufacturesettings: "Ajustes de fabricación",
        Showbuyingprice: "Mostrar precio de compra / costo del producto",
        Showadditionalcost: "Mostrar costo adicional",
        Costbreakdown: "Desglose de costos",
        Unitcost: "Costo unitario",
        Rawmaterialstotal: "Total de materias primas",
        Confirmentry: "Confirmar entrada",
        SaveSerials: "Guardar números de serie",
        SerialNumber: "Número de serie",
        selected: "seleccionado",
        added: "agregado",
        Serialnumbers: "Números de serie",
        ResetAll: "Restablecer todo",
        Wecouldnfindthis: "No pudimos encontrar ningún número de serie disponible para este producto.",
        Nounitsfound: "No se encontraron unidades",
        Searchingserialnumbers: "Buscando números de serie...",
        Scanorenterstock: "Escanea o ingresa números de serie para stock nuevo",
        Whataserialnumber: "¿Qué es un número de serie?",
        Auniqueidentifieryourinventorylifecycle: "Un identificador único por unidad — te permite rastrear cada artículo individual a lo largo del ciclo de vida del inventario.",
        Trackedstockout: "Salida de stock rastreada",
        Chooseexactlyselected: "Elige exactamente qué números de serie salen. Solo se muestran los números de serie ingresados para este producto — la cantidad se bloquea una vez que hayas seleccionado ",
        SelectSerialstoout: " - Seleccionar números de serie para salida",
        Thisinvoicegeneratedusingwwwsimplstockco: "Esta factura se generó usando www.simplstock.co",
        AuthorizedSignature: "Firma autorizada",
        Invoicesettings: "Configuración de factura",
        Draw: "Dibujar",
        Taptoselectordeselectitems: "Toca para seleccionar o deseleccionar elementos",
        Thissignaturewillbeadded: "Esta firma se añadirá en la parte inferior de tu factura impresa.",
        SignatureOptions: "Opciones de firma",
        Upload: "Subir",
        DrawSignature: "Dibujar firma",
        UploadSignature: "Subir firma",
        Clear: "Limpiar",
        ShowStaffName: "nombre del empleado",
        ShowSKU: "SKU",
        ShowBusinessName: "nombre de la empresa",
        ShowProductName: "nombre del producto",
        ShowBusinessPhoneNumber: "teléfono",
        ShowBusinessEmail: "correo",
        ShowBusinessAddress: "dirección",
        ShowProductImage: "imagen del producto",
        ShowPaymentDetails: "detalles de pago",
        ShowCategory: "categoría",
        ShowVariant: "variante",
        ShowWarehouse: "almacén",
        ShowAttributes: "atributos",
        ShowQuantity: "cantidad",
        ShowDiscount: "descuento",
        ShowTax: "impuesto",
        ShowPrice: "precio",
        ShowTotalPrice: "precio total del producto",
        ShowExpenses: "gastos",
        ShowSignature: "firma",
        ShowNote: "nota",
        showAttachment: "archivo adjunto",
        ShowSerialNumber: "número de serie",
        Invoicesettingsapplied: "Configuración de factura aplicada. Verifique la factura para ver los cambios.",
        EnterSerialNumber: "Ingresar número de serie",
    },
    FewLocal: {
        SelectBin: "Seleccionar Ubicación",
        Live: "En vivo",
        Monitorinventorystocklevels: "Monitorear inventario, movimientos y niveles de stock",
        StockControlCentre: "Centro de Control de Stock",
        Nochartdataavailable: "No hay datos de gráfico disponibles",
        Disabled: "Deshabilitado",
        Enabled: "Habilitado"
    },
    Bin: {
        Bin: "Ubicación",
        Add: "Agregar",
        NoBinsAddedYet: "Aún no se han agregado ubicaciones",
        BinLocationsHelp: "Las ubicaciones de bins te ayudan a rastrear el stock por posición exacta dentro de este almacén — sin más búsquedas.",
        NameThemByPosition: "Nómbralas por posición:",
        AddBinLocation: "Agregar ubicación de bin",
        BinLocations: "ubicaciones de bin",
        BinNameRequired: "El nombre del bin es obligatorio",
        EditBin: "Editar bin",
        AddBin: "Agregar bin",
        EnterBinName: "Nombre del bin",
        EnterBinNamePlaceholder: "Ingrese nombre del bin",
        BinStatus: "Estado del bin",
        BinNotes: "Notas",
        EnterBinNotesPlaceholder: "Agregue algunas notas...",
        ViewInventory: "Ver inventario",
        Inventory: "Inventario",
        TrymatchingadifferentSKUname: "Intente con un SKU o nombre diferente.",
        Thisbinlocationcurrentlyempty: "Esta ubicación de bin está actualmente vacía.",
        Loadingbins: "Cargando bins...",
        bins: "Bins",
        ManageBin: "Gestionar Bin",
        Print: "Imprimir",
        SBin: "Bin Origen",
        DBin: "Bin Destino"
    },
    WarehouseExcel: {
        title: "Subir Almacenes y Ubicaciones de Bin",
        description: "Siga los pasos a continuación para crear masivamente almacenes junto con sus ubicaciones de bin usando un archivo Excel.",
        bulkUploadGuide: "Guía de Carga Masiva",
        step1: "Paso 1",
        downloadTemplate: "Descargar plantilla Excel",
        downloadTemplateDesc: "Obtenga la plantilla oficial con todos los encabezados de columna requeridos. No cambie ni elimine ninguna columna.",
        downloadTemplateBtn: "Descargar Plantilla",
        step2: "Paso 2",
        fillExcelFile: "Completar el archivo Excel",
        fillExcelDesc: "Cada fila representa un almacén. Complete todas las columnas — para ubicaciones de bin, ingrese todos los nombres separados por comas en la columna <code>Bin Names</code>.",
        step3: "Paso 3",
        thingsToKeepInMind: "Cosas a tener en cuenta",
        rulesDesc: "Antes de subir, asegúrese de que su archivo siga estas reglas.",
        step4: "Paso 4",
        uploadYourFile: "Subir su archivo",
        uploadDesc: "Una vez completado, suba el archivo a continuación. El sistema creará todos los almacenes y ubicaciones de bin automáticamente.",
        rules: ["Una fila por almacén", "Nombres de bin separados por comas en una celda", "No renombrar encabezados de columna", "Se omiten nombres de bin duplicados por almacén", "Número de teléfono con código de país", "Solo archivos .xlsx o .xls"],
        dropFileHere: "Suelte su archivo Excel aquí",
        supports: "Compatible con .xlsx y .xls — máximo 10 MB",
        chooseFileUpload: "Elegir archivo y subir",
        parsing: "Analizando archivo...",
        invalidFileType: "Tipo de archivo no válido. Suba un archivo Excel.",
        noData: "No se encontraron datos en Excel",
        failedToRead: "No se pudo leer el archivo Excel",
        unableToRead: "No se pudo leer el archivo.",
        reviewTitle: "Revisar datos de almacenes",
        reviewSubtitle: "Verificación final antes de importar.",
        changeFile: "Cambiar archivo",
        rowsFound: "filas encontradas",
        cancel: "Cancelar",
        finalizeImport: "Finalizar e Importar",
        importing: "Importando...",
        success: "Éxito",
        allWarehouseUploadedSuccess: "Todos los almacenes se subieron correctamente",
        failed: "Falló",
        bulkUploadFailed: "Carga masiva fallida",
        error: "Error",
        binNamesNote: "En la columna <strong>Bin Names</strong>, ingrese todas las ubicaciones de bin en una sola celda separadas por comas — ej: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Nombre del Almacén", email: "Correo Electrónico", phoneNumber: "Número de Teléfono", location: "Ubicación", binNames: "Nombres de Bin" }
    },
    VariantTemplate: {
        VariantTemplates: "Plantillas de Variantes",
        Managereusablevariantpatterns: "Gestionar patrones de variantes reutilizables",
        BinTransferHistory: "Historial de Transferencias de Bin",
        Trackmovementsacrossbins: "Seguimiento de movimientos entre bins",
        SerialNumberHistory: "Historial de Números de Serie",
        Trackproductserialnumberactivity: "Seguimiento de la actividad de números de serie del producto",
        Period: "Período",
        Nohistoryfound: "No se encontró historial",
        Searchserialnumbers: "Buscar números de serie...",
        SerialNumbersHistory: "Historial de Números de Serie",
        Serialnumberhistoryglance: "Historial de números de serie de un vistazo.",
        Noserialnumbersfound: "No se encontraron números de serie",
        Noactivityhistoryfound: "No se encontró historial de actividad",
        Statussetto: "Estado establecido en",
        Timeline: "Línea de tiempo",
        Managereusableproductvariantpatterns: "Gestionar patrones de variantes de productos reutilizables.",
        DeleteTemplate: "Eliminar Plantilla",
        Areyousureyouwanttemplate: "¿Estás seguro de que quieres eliminar esta plantilla?",
        CreateNewTemplate: "Crear Nueva Plantilla",
        CreateTemplate: "Crear Plantilla",
        EditTemplate: "Editar Plantilla",
        UnlimitedTemplates: "Plantillas ilimitadas",
        CreateAsManyTemplates: "Crea tantas plantillas como necesites — Ropa, Calzado, Electrónica y más.",
        PickWhileAddingProduct: "Seleccionar al agregar producto",
        OpenTemplateLibrary: "Abre tu biblioteca de plantillas y selecciona nombres de variantes en segundos.",
        MixFromMultipleTemplates: "Mezclar de múltiples plantillas",
        SelectFromMultipleTemplates: "Selecciona nombres de variantes de más de una plantilla para un solo producto — totalmente flexible.",
        EditAnytime: "Editar en cualquier momento",
        RenameTemplatesAnytime: "Cambia el nombre de las plantillas, agrega o elimina nombres de variantes cuando cambie tu catálogo.",
        StayConsistent: "Mantén la consistencia",
        SameVariantNamesAcrossAll: "Mismos nombres de variantes en todos los productos. Sin errores tipográficos, sin duplicados, sin adivinar.",
        BuildOnceUseEverywhere: "Crea una vez, usa en todas partes",
        StopReEnteringVariantNames: "Deja de volver a escribir los mismos nombres de variantes para cada producto. Crea una plantilla, asígnale nombres de variantes y vuélvela a usar al instante.",
        Updateexistingvariantcombinations: "Actualizar combinaciones de variantes existentes",
        Definenewvariantcombinations: "Definir nuevas combinaciones de variantes",
        TemplateName: "Nombre de la Plantilla",
        AddVariantOptions: "Agregar Opciones de Variante",
        SmallMedium: "ej. Pequeño, Mediano...",
        VariantsList: "Lista de Variantes",
        Nooptionsaddedyet: "Aún no se han agregado opciones",
        SaveTemplate: "Guardar Plantilla",
        egSizesColorsetc: "ej. Tallas de Camiseta, Colores, etc.",
        Pleaseentertemplatename: "Por favor ingresa un nombre de plantilla",
        Pleaseaddatleastonevariantoption: "Por favor agrega al menos una opción de variante",
        Templateupdatedsuccessfully: "Plantilla actualizada con éxito",
        Templatecreatedsuccessfully: "Plantilla creada con éxito",
        Failedtosavetemplate: "Error al guardar la plantilla",
        Transfer: "Transferir",
        Editassignment: "Editar asignación",
        Updateproductdetailsinbin: "Actualizar detalles del producto en el bin",
        Editinginbin: "Editando en bin",
        ConfirmUpdate: "Confirmar Actualización",
        ConfirmAssign: "Confirmar Asignación",
        Assignanotherproduct: "Asignar otro producto",
        TransferBin: "Transferir Bin",
        SourceBin: "Bin de Origen",
        DestinationBin: "Bin de Destino",
        SelectSourceBin: "Seleccionar Bin de Origen",
        SelectDestinationBin: "Seleccionar Bin de Destino",
        Unit: "Unidad",
        ManageVariant: "Gestionar Variante",
        CreateSKUvariationsyourproduct: "Crear variaciones SKU para tu producto",
        Assigningvariationsto: "Asignando variaciones a",
        Novariantsaddedyet: "Aún no se han agregado variantes",
        AddedVariants: "Variantes Agregadas",
        AddVariantsfromTemplate: "Agregar Variantes desde Plantilla",
        Pickatemplateandselectvariantnames: "Elige una plantilla y selecciona nombres de variantes",
        ChooseaTemplate: "Elige una Plantilla",
        Selectvariantnamestoadd: "Selecciona nombres de variantes para agregar",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Selecciona una plantilla para elegir nombres de variantes. Puedes agregar desde múltiples.",
        Loadingtemplates: "Cargando plantillas...",
        Backtotemplates: "Volver a plantillas",
        Selectallindividualadd: "Selecciona todo o nombres de variantes individuales para agregar.",
        VariantNames: "Nombres de Variantes",
        MediaDescription: "Medios y Descripción",
        Addattachmentsandproductnotes: "Agregar adjuntos y notas del producto",
        ProductMedia: "Medios del Producto"
    },
    AddProductGuide: {
        title: "Agregar cantidad inicial después de guardar",
        description: "Los productos no tienen un campo de cantidad aquí. Una vez guardado, use 'Entrada de Stock' para registrar su stock inicial — con control total sobre ubicación y seguimiento.",
        steps: {
            quantity: { title: "Cantidad", sub: "Establecer stock inicial" },
            binLocation: { title: "Ubicación de Bin", sub: "Pasillo, estante, posición — ej. A-01-03" },
            serialNumbers: { title: "Números de serie", sub: "Rastrear cada unidad individualmente" },
            warehouse: { title: "Almacén", sub: "En qué ubicación está almacenado" },
            batchExpiry: { title: "Lote / Caducidad", sub: "Agrupar stock por número de lote" }
        },
        actions: { close: "Cerrar" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "No se encontraron órdenes de transferencia",
        Itemshistory: "Los artículos que transfieras entre almacenes aparecerán aquí para seguimiento e historial.",
        CreateTransfer: "Crear Transferencia"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Toca el producto para fabricar",
        Selectproductfrombelow: "Selecciona un producto de la lista",
        SetupANewProduct: "Configurar nuevo producto",
        DefineAProductAdditsrawmaterial: "Definir un producto y agregar sus materias primas",
        ManufacturingSetup: "Configuración de fabricación",
        Pickproducttodefineitsproductiondetails: "Elige un producto para definir sus detalles de producción",
        ConfigureManufacturing: "Configurar fabricación",
        SelectRawMaterial: "Seleccionar materia prima",
        NoRawMaterials: "Sin materias primas",
        Definecomponentsneededtoproduct: "Define los componentes necesarios para fabricar este producto.",
        NoAdditionalCosts: "Sin costos adicionales",
        Addlaboroverheadlogisticalcharges: "Agrega costos de mano de obra, generales o logísticos.",
        AddAdditionalCost: "Agregar costo adicional",
        AddCost: "Agregar costo",
        TotalPrice: "Precio total",
        SelectCharges: "Seleccionar cargos",
        EnterEstimatedCost: "Ingresar costo estimado",
        QtyRequried: "Cantidad requerida",
        Manufacturing: "Fabricación",
        Outputfinishedgoodsdestination: "Destino de productos terminados",
        Manufacturingquantity: "Cantidad de fabricación",
        Storefinishedgoodsat: "Almacenar productos terminados en",
        Rawmaterials: "Materias primas",
        StockSelection: "Selección de inventario",
        AdditionalCosts: "Costos adicionales",
        Quantityconsume: "Cantidad a consumir",
        Totalmanufacturingcost: "Costo total de fabricación",
        Sumofrawmaterialcosts: "Suma de todos los costos de materias primas",
        CustomManufacturingCharge: "Cargo de fabricación personalizado",
        Addextralikelaboroverheadrepairs: "Agrega costos adicionales como mano de obra, gastos generales o reparaciones.",
        CalculatedTotal: "Total calculado",
        AddRawMaterial: "Agregar materia prima",
        ConfigureRawMaterial: "Configurar materia prima",
        Thisoutputunit: "Esta es la cantidad base requerida por unidad de salida.",
        ChangeProduct: "Cambiar producto",
        AddtoList: "Agregar a la lista",
        ManufacturedSuccessfully: "Fabricado con éxito",
        Manufacture: "Fabricar",
        EditDeleteHistory: "Historial de Editar/Eliminar",
        ManageOrder: "Gestionar Pedido",
        ManageBatch: "Gestionar lote",
        Paymentnotavailablehere: "Pago no disponible aquí",
        Thisrecordisanorderorderitself: "Este registro es de un pedido. El pago solo puede registrarse desde el pedido.",
        Torecorpaymenttheorderthethere: "Para registrar un pago, ve al pedido vinculado y usa la opción <b>Registrar pago</b> allí.",
        GotoOrder: "Ir al pedido"
    },
    CustomerExcel: {
        title: "Subir Clientes",
        description: "Siga los pasos a continuación para crear clientes de forma masiva utilizando un archivo Excel.",
        bulkUploadGuide: "Guía de Carga Masiva",
        step1: "Paso 1",
        downloadTemplate: "Descargar plantilla de Excel",
        downloadTemplateDesc: "Obtenga la plantilla oficial con todos los encabezados de columna requeridos.",
        downloadTemplateBtn: "Descargar Plantilla",
        step2: "Paso 2",
        fillExcelFile: "Completar el archivo Excel",
        fillExcelDesc: "Cada fila representa un cliente. Complete todas las columnas según sea necesario.",
        step3: "Paso 3",
        thingsToKeepInMind: "Cosas a tener en cuenta",
        rulesDesc: "Antes de subir, asegúrese de que su archivo siga estas reglas para evitar errores.",
        step4: "Paso 4",
        uploadYourFile: "Subir su archivo",
        uploadDesc: "Una vez completado, suba el archivo a continuación. El sistema creará todos los clientes automáticamente.",
        rules: [
            "Solo una fila por cliente",
            "No cambie el nombre de los encabezados de columna",
            "Número de contacto con código de país",
            "Solo se aceptan archivos .xlsx o .xls"
        ],
        dropFileHere: "Arrastre su archivo Excel aquí",
        supports: "Soporta .xlsx y .xls — máximo 10 MB",
        chooseFileUpload: "Elegir Archivo y Subir",
        parsing: "Analizando archivo...",
        invalidFileType: "Tipo de archivo no válido. Por favor, suba un archivo Excel.",
        noData: "No se encontraron datos en el Excel",
        failedToRead: "Error al leer el archivo Excel",
        unableToRead: "No se puede leer el archivo.",
        reviewTitle: "Revisar Datos de Clientes",
        reviewSubtitle: "Verificación final antes de importar a su negocio.",
        changeFile: "Cambiar Archivo",
        rowsFound: "filas encontradas en el archivo",
        cancel: "Cancelar",
        finalizeImport: "Finalizar e Importar",
        importing: "Importando...",
        success: "Éxito",
        allCustomerUploadedSuccess: "Todos los clientes se subieron con éxito",
        failed: "Error",
        bulkUploadFailed: "La carga masiva falló",
        error: "Error",
        headers: {
            customerName: "Nombre del Cliente",
            phoneNumber: "Contacto",
            address: "Dirección",
            note: "Nota"
        }
    },
    SupplierExcel: {
        title: "Subir Proveedores",
        description: "Siga los pasos a continuación para crear proveedores de forma masiva utilizando un archivo Excel.",
        bulkUploadGuide: "Guía de Carga Masiva",
        step1: "Paso 1",
        downloadTemplate: "Descargar plantilla de Excel",
        downloadTemplateDesc: "Obtenga la plantilla oficial con todos los encabezados de columna requeridos.",
        downloadTemplateBtn: "Descargar Plantilla",
        step2: "Paso 2",
        fillExcelFile: "Completar el archivo Excel",
        fillExcelDesc: "Cada fila representa un proveedor. Complete todas las columnas según sea necesario.",
        step3: "Paso 3",
        thingsToKeepInMind: "Cosas a tener en cuenta",
        rulesDesc: "Antes de subir, asegúrese de que su archivo siga estas reglas para evitar errores.",
        step4: "Paso 4",
        uploadYourFile: "Subir su archivo",
        uploadDesc: "Una vez completado, suba el archivo a continuación. El sistema creará todos los proveedores automáticamente.",
        rules: [
            "Solo una fila por proveedor",
            "No cambie el nombre de los encabezados de columna",
            "Número de contacto con código de país",
            "Solo se aceptan archivos .xlsx o .xls"
        ],
        dropFileHere: "Arrastre su archivo Excel aquí",
        supports: "Soporta .xlsx y .xls — máximo 10 MB",
        chooseFileUpload: "Elegir Archivo y Subir",
        parsing: "Analizando archivo...",
        invalidFileType: "Tipo de archivo no válido. Por favor, suba un archivo Excel.",
        noData: "No se encontraron datos en el Excel",
        failedToRead: "Error al leer el archivo Excel",
        unableToRead: "No se puede leer el archivo.",
        reviewTitle: "Revisar Datos de Proveedores",
        reviewSubtitle: "Verificación final antes de importar a su negocio.",
        changeFile: "Cambiar Archivo",
        rowsFound: "filas encontradas en el archivo",
        cancel: "Cancelar",
        finalizeImport: "Finalizar e Importar",
        importing: "Importando...",
        success: "Éxito",
        allSupplierUploadedSuccess: "Todos los proveedores se subieron con éxito",
        failed: "Error",
        bulkUploadFailed: "La carga masiva falló",
        error: "Error",
        headers: {
            supplierName: "Nombre del Proveedor",
            phoneNumber: "Contacto",
            bankName: "Nombre del Banco",
            accountHolderName: "Nombre del Titular",
            accountNumber: "Número de Cuenta",
            note: "Nota"
        }
    },
    ReplaceReturnLocal: {
        BuyingPrice: "Precio de compra",
        SellingPrice: "Precio de venta",
        ReplacedWith: "Reemplazado con",
        Noreplacementhistoryfound: "No se encontró historial de reemplazo",
        Noreturnhistoryfound: "No se encontró historial de devoluciones",
        Productbeingreturned: "Producto que se devuelve",
        Required: "Requerido",
        Selectreturnedproduct: "Seleccionar producto devuelto",
        Searchnamescanbarcode: "Buscar por nombre, SKU o escanear código de barras",
        Browse: "Explorar",
        Stockhandling: "Gestión de entrada de stock",
        Stockinreturnedproduct: "Ingresar producto devuelto al stock",
        Ontoinventory: "Encendido — el artículo devuelto se agregará nuevamente al inventario",
        Offreturnedonly: "Apagado — el artículo se registrará solo como devuelto",
        Usedrestock: "Se utiliza para calcular el ajuste de ganancias al reponer stock",
        Willaddedbackconfirmation: "Se volverá a agregar al inventario al confirmar",
        Returnreason: "Motivo de la devolución",
        Optional: "Opcional",
        SelectReason: "Seleccionar motivo",
        Additionalnotes: "Notas adicionales",
        Describeofcustomerexplanation: "Describa la condición del artículo devuelto, cualquier daño visible, la explicación del cliente...",
        Requiredmustfilledcontinue: "Los campos obligatorios deben completarse para continuar",
        Reviewdetailsbeforeconfirming: "Revise los detalles antes de confirmar",
        Replacementproductwilldeductedinventoryconfirmation: "El producto de reemplazo se deducirá de su inventario al confirmar.",
        Choosereplacementproduct: "Elegir producto de reemplazo",
        Willdeductedfrominventoryconfirm: "Se deducirá del inventario al confirmar",
        Thesewillattachedothereturnrecord: "Estas imágenes se adjuntarán al registro de devolución",
        Replacementitem: "Artículo de reemplazo",
        Addanotherproduct: "Agregar otro producto",
        Replacementproductwillbe: "El producto de reemplazo será",
        deducted: "deducido",
        fromyourinventoryconfirmation: "de su inventario al confirmar.",
        productadjustedusingprice: "El producto devuelto se repondrá y la ganancia se ajustará utilizando el precio de venta original.",
        Willloggedreturnedonlynotrestocked: "Se registrará solo como devuelto — no se repondrá",
        Returnonly: "Solo devolución",
        Imagesofreturnedproduct: "Imágenes del producto devuelto",
        Returnedproductwill: "El producto devuelto",
        not: "no",
        berestockedloggedreturnedonly: "se repondrá — se registrará solo como devuelto.",
        AddImage: "Agregar imagen",
        STOCKIN: "ENTRADA DE STOCK",
        LOGONLY: "SOLO REGISTRO",
        ContinuetoReview: "Continuar a la revisión →",
        Confirmreplacement: "Confirmar reemplazo",
        Confirmreturn: "Confirmar devolución",
        Filldetailsbelowproceed: "Complete los detalles a continuación para continuar",
        Review: "Revisar",
        editdetails: "Editar detalles",
        Configurereturndetails: "Configurar detalles de devolución",
        Configurereplacementdetails: "Configurar detalles de reemplazo",
        SelectSource: "Seleccionar fuente",
        Returning: "Devolviendo",
        Replacement: "Reemplazo",
        WalkCustomer: "Cliente directo",
        RETURNEDPRODUCT: "PRODUCTO DEVUELTO",
        REPLACEMENTPRODUCT: "PRODUCTO DE REEMPLAZO",
        STOCKOUT: "SALIDA DE STOCK",
        Netinventoryimpact: "Impacto neto en inventario",
        Replacementitemcost: "Costo del artículo de reemplazo",
        Returneditemrestockvalue: "Valor de reposición del artículo devuelto",
        PROFITINVENTORYSUMMARY: "RESUMEN DE GANANCIAS E INVENTARIO",
        Inventoryaction: "Acción de inventario",
        Valuededucted: "Valor deducido",
        Profitadjustment: "Ajuste de ganancias",
        stockedout: " salida de stock",
        restocked: " reabastecido",
        Noaction: "Sin acción",
        Valuebeingreturned: "Valor devuelto",
        Willberestocked: "Será reabastecido",
        Willbe: "Será",
        logged: "registrado",
        ON: "ENCENDIDO",
        OFF: "APAGADO",
        Linked: "Vinculado",
        Pleaseselectreturnedproduct: "Por favor seleccione un producto devuelto",
        Quantityrequired: "La cantidad es obligatoria",
        Buyingpricerequired: "El precio de compra es obligatorio",
        Pleaseaddleastreplacementproduct: "Por favor agregue al menos un producto de reemplazo",
        Pleaseconfigurereturnedproductdetails: "Por favor configure los detalles del producto devuelto",
        Pleaseselectcustomer: "Por favor seleccione un cliente",
        Returndateisrequired: "La fecha de devolución es obligatoria",
        Pleasefillallrequiredfields: "Por favor complete todos los campos obligatorios",
        Wildeductedfrominventory: "Se deducirá del inventario",
        Currentprice: "Precio actual",
        Defectivedamaged: "Defectuoso / dañado",
        Wrongitemreceived: "Artículo incorrecto recibido",
        Customerchangedmind: "El cliente cambió de opinión",
        Sizefitissue: "Problema de talla / ajuste",
        Notasdescribed: "No es como se describe",
        Other: "Otro",
        Originalsaleprice: "Precio de venta original (ajuste de ganancia)",
        Addedbackinventory: "Agregado de nuevo al inventario",
        Notaddedinventory: "No agregado al inventario",
        replacedwith: "reemplazado con",
        deductedfrominventory: "deducido del inventario",
        RETURNWITHSTOCKIN: "DEVOLUCIÓN · CON ENTRADA DE STOCK",
        RETURNNOSTOCKIN: "DEVOLUCIÓN · SIN ENTRADA DE STOCK",
        MULTIPLEREPLACEMENTS: "MÚLTIPLES REEMPLAZOS",
        SINGLEREPLACEMENT: "REEMPLAZO ÚNICO",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "DEVUELTO · STOCK EN",
        REPLACEMENTSTOCKOUT: "REEMPLAZO · STOCK FUERA",
        Returnonlylogsthisentry: "La devolución solo registra esta entrada —",
        nostockwillbeaddedorremoved: "no se agregará ni eliminará stock",
        frominventory: "del inventario.",
        Whentousethis: "Cuándo usar esto:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Use Devolución al final del día para registrar artículos enviados para ventas que regresaron dañados o inutilizables — artículos que desea rastrear pero que no puede volver a agregar al inventario.",
        Youcanviewallpastreturnentriesin: "Puede ver todas las entradas de devoluciones pasadas en",
        ReturnHistory: "Historial de devoluciones",
        underthe: "bajo la pestaña",
        Others: "Otros",
        tab: ".",
        Negativestocktransactiondisabled: "Las transacciones de acciones negativas están deshabilitadas."
    },
    NewRLocal: {
        Originalsaleprice: "Precio de venta original",
        Editinghistoryonlyinventorystaysunchanged: "Editar historial solamente — el inventario permanece sin cambios.",
        Changeshereupdatethisdetailsquantitiesaffected: "Los cambios aquí actualizan solo los detalles de este registro (motivo, fecha, notas). Sus cantidades de stock reales, ubicaciones de bins y datos de productos no se ven afectados.",
        Needtofixinventorylevelsinstead: "¿Necesita corregir los niveles de inventario en su lugar?",
        AdjustStock: "Ajustar Stock",
        Refund: "Reembolso",
        ImportantNote: "Nota importante",
        Pleasereviewbeforecontinuing: "Por favor revise antes de continuar",
        Onceshippedreceivedanyupdatesmadeorder: "Una vez que un pedido se envía o recibe, cualquier actualización realizada en el pedido no se reflejará en el historial de transacciones.",
        Thisundone: "Esto eliminará permanentemente el pedido. Esta acción no se puede deshacer.",
        Inventorywilladjustedautomatically: "El inventario no se ajustará automáticamente",
        Deletingthisreversevedshippedyouwillneed: "Eliminar este pedido no revierte ningún cambio de stock. Si los artículos ya fueron recibidos/enviados, deberá",
        reflectthecorrectstocklevels: "para reflejar los niveles de stock correctos.",
        manuallyadjustyourinventory: "ajustar manualmente su inventario",
        Addremovestockforitemsthatwereshipped: "Agregar o quitar stock para artículos que fueron enviados",
        Addremovestockforitemsthatwerereceived: "Agregar o quitar stock para artículos que fueron recibidos",
        Updatecostrecordspaymentwaalreadymade: "Actualizar registros de costos si el pago ya fue realizado",
        Reconcilerecordsandoutstandingpayments: "Conciliar registros y pagos pendientes"
    },
    ReceivablesLocal: {
        Receivables: "Cuentas por Cobrar",
        Manageandtrackcustomerduebalances: "Gestionar y rastrear saldos pendientes de clientes",
        Viewcustomerduebalancereport: "Ver reporte de saldo pendiente de clientes",
        Viewsupplierduebalancereport: "Ver reporte de saldo pendiente de proveedores",
        DueBalance: "Saldo Pendiente",
        Unpaid: "Sin Pagar",
        PartiallyPaid: "Parcialmente Pagado",
        Paid: "Pagado",
        HighestBalance: "Saldo Más Alto",
        LowestBalance: "Saldo Más Bajo",
        Filldetailsrecordpayment: "Complete los detalles para registrar el pago",
        NewPaymentEntry: "Nueva Entrada de Pago",
        EditPaymentEntry: "Editar Entrada de Pago",
        Nosuppliersfound: "No se encontraron proveedores",
        Nocustomersfound: "No se encontraron clientes",
        LowtoHigh: "De Menor a Mayor",
        HightoLow: "De Mayor a Menor",
        AttachmentUploadedSc: "Adjunto subido correctamente",
        AttachmentUploadedF: "Error al subir el adjunto",
        Pay: "Pagar",
        NoBillsFound: "No se encontraron facturas",
        Thiscustomerhasunpaidbills: "Este cliente no tiene facturas pendientes.",
        TotalDue: "Total Pendiente",
        BillsFound: "Facturas Encontradas",
        DeselectAll: "Deseleccionar Todo",
        SelectAll: "Seleccionar Todo",
        ShowDetails: "Mostrar detalles"
    },
    AssetsNewLocal: {
        Assignedon: "Asignado el",
        Total: "Total",
        Assigned: "Asignado",
        Remaining: "Restante",
        Available: "Disponible",
        NoSerialNumbers: "Sin números de serie",
        UpdateExistingAssetDetails: "Actualizar detalles de activo existente",
        RegisterNewBusinessAsset: "Registrar un nuevo activo comercial",
        BasicInformation: "Información básica",
        AssetDetails: "Detalles del activo",
        Quantity: "Cantidad",
        SerialNumbers: "Números de serie",
        SerialNumberPlaceholder: "Número de serie",
        AddSerialNumber: "Agregar número de serie",
        SerialNumbersOptional: "Los números de serie son opcionales. Puede agregar hasta",
        AssetImages: "Imágenes del activo",
        AdditionalNotes: "Notas adicionales",
        AdditionalNotesPlaceholder: "Cualquier detalle adicional o historial de mantenimiento...",
        Updating: "Actualizando...",
        Adding: "Agregando...",
        ITEquipmentPlaceholder: "ej. Equipos de TI",
        LoadingMoreActivities: "Cargando más actividades...",
        AssignedAssets: "Activos Asignados",
        Noassetsassignedstaffmember: "No hay activos asignados a este empleado.",
        Assignassetstaff: "Asignar un activo al personal",
        Returnassetfromstaff: "Devolver este activo del personal",
        AssignmentDetails: "Detalles de la asignación",
        Serial: "Serial",
        ViewAssets: "Ver Todos los Activos",
        ViewByStaff: "Ver por Personal",
        AssignedHistory: "Historial de Asignaciones",
        Returned: "Devuelto",
        Returnedon: "Devuelto el",
        ReturnedBy: "Devuelto por",
        AssignedTo: "Asignado a",
        NoHistoryRecords: "Sin registros de historial",
        Selectstaffmemberviewtheirassets: "Seleccione un miembro del personal para ver sus activos.",
        Deleted: "ELIMINADO",
        searchPlaceholder: "Buscar activo por nombre o número de serie..."
    },
    InventoryCountLocale: {
        InventoryCount: "Conteo de Inventario",
        Viewinventorycountreport: "Ver reporte de conteo de inventario",
        ItemsCount: "Conteo de Artículos",
        All: "Todos",
        InProgress: "En Progreso",
        Submitted: "Enviado",
        awaitingreview: "En Espera de Revisión",
        EditInventoryCount: "Editar Conteo de Inventario",
        NewInventoryCount: "Nuevo Conteo de Inventario",
        Modifyinventorycountsheetdetails: "Modificar detalles de la hoja de conteo",
        Startanewinventorycountsheet: "Iniciar nueva hoja de conteo",
        GeneralInformation: "Información General",
        Title: "Título",
        SaveChanges: "Guardar Cambios",
        Selectproductsforthisinventorycountsheet: "Seleccionar productos para esta hoja de conteo",
        InventoryCountDetails: "Detalles del Conteo",
        Inventorycountsheetdetails: "Detalles de la hoja de conteo",
        Viewingdetailsforcountsheet: "Viendo detalles de la hoja de conteo",
        Started: "Iniciado",
        TaskSheets: "Hojas de Tareas",
        Allitems: "Todos los artículos",
        NotStarted: "No Iniciado",
        Completed: "Completado",
        Results: "Resultados",
        ViewResults: "Ver Resultados",
        DeleteInventoryCount: "Eliminar Conteo de Inventario",
        Viewingtransactionandadjustments: "Viendo registros de transacciones y ajustes de stock",
        Productsadjusted: "Productos ajustados",
        Assignee: "Asignado a",
        Tasksheetdetails: "Detalles de la hoja de tarea",
        Draft: "Borrador",
        VariantQuantities: "Cantidades de Variantes",
        AssignedProducts: "Productos Asignados",
        ReturnAsset: "Devolver Activo",
        EditTasksheet: "Editar Hoja de Tarea",
        NewTasksheet: "Nueva Hoja de Tarea",
        Updatetasksheetdetails: "Actualizar detalles de la hoja de tarea",
        Starttasksheetforthisinventorycount: "Iniciar nueva hoja de tarea para este conteo",
        TaskSheetInformation: "Información de la Hoja de Tarea",
        SheetTitle: "Título de la Hoja",
        Entersheettitle: "Ingrese título de la hoja",
        SubmissionResult: "Resultado de Envío",
        ReviewChanges: "Revisar Cambios",
        Viewingsubmissionresultsforthisinventorycount: "Viendo resultados de envío para este conteo",
        Reviewyourinventorycountbeforesubmitting: "Revise su conteo de inventario antes de enviar"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Error al cargar los conteos",
        NoInventoryCounts: "Sin Conteos de Inventario",
        NoMatches: "Sin Coincidencias",
        Therearenoinventorycountswiththestatus: "No hay conteos de inventario con el estado",
        Noinventorycountsfoundyoursearchterm: "No se encontraron conteos de inventario que coincidan con tu término de búsqueda.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Aún no hay conteos de inventario registrados para este negocio."
    },
    StockinModalP: {
        StockInNow: "Ingresar Stock Ahora",
        Settheopeningquantityforthisproductrightnow: "Establece la cantidad inicial para este producto ahora.",
        Addinitialstock: "¿Agregar stock inicial?",
        dothislater: "Lo haré más tarde",
        Productadded: "¡Producto agregado!",
        isready: "está listo.",
        SeeHowItWorks: "Ver Cómo Funciona",
        NoSalesOrdersFound: "No se encontraron órdenes de venta",
        NoPurchaseOrdersFound: "No se encontraron órdenes de compra",
        Startcreatingoutgoinginventoryrevenue: "Comienza a crear órdenes de venta para rastrear tu inventario saliente e ingresos.",
        Trackrestockssupplierplace: "Rastrea las reposiciones de inventario y órdenes de proveedores en un solo lugar.",
        CreateSalesOrder: "Crear Orden de Venta",
        CreatePurchaseOrder: "Crear Orden de Compra",
    }
    ,
    dialy_report: "Reporte de Movimiento Diario",
    Quotation: "Cotización",
    Quote: "Cotización",
    Assignee: "Asignado a",
    dayStart: "Inicio del día",

    ShowTotalAmount: "Monto Total",


    tutorial: {
        watchTitle: 'Mira los tutoriales paso a paso',
        watchDesc: 'Aprende SimplyStock en nuestro canal de YouTube',
        modalTitle: 'Mantente a la vanguardia con SimplyStock',
        modalDesc: 'Suscríbete para recibir nuevos tutoriales en el momento en que se publiquen',
        feature1Title: 'Nuevos tutoriales de funciones',
        feature1Sub: 'Cada nueva actualización se explica con un breve vídeo, para que nunca te pierdas las novedades',
        feature2Title: 'Vídeos instructivos rápidos',
        feature2Sub: 'Configure el inventario, las facturas, el acceso del personal y más en menos de 5 minutos',
        feature3Title: 'Notificaciones instantáneas.',
        feature3Sub: 'Reciba notificaciones en el momento en que se publique un nuevo tutorial: aprenda a su propio ritmo',
        feature4Title: '100% gratis, siempre',
        feature4Sub: 'Todos los tutoriales son gratuitos para siempre: no es necesario iniciar sesión ni suscribirse',
        subscribeBtn: 'Suscríbete a SimplyStock',
        maybeLater: 'Quizás más tarde'
    }
    ,
    dailyCashReport: {
        "title": "Reporte Diario de Caja",
        "subtitle": "Quién pagó qué, en qué fecha y qué se debe aún — agrupado por detalle de ventas.",
        "totalSales": "Ventas totales",
        "cashReceived": "Total Recibido",
        "outstanding": "Pendiente",
        "collectionRate": "Tasa de cobro",
        "grandTotalAllDates": "GRAN TOTAL (todas las fechas)",
        "totalLabel": "Total",
        "loading": "Cargando...",
        "noData": "No se encontraron datos para el rango de fechas seleccionado.",
        "loadingMore": "Cargando más..."
    },
    dailyCashReportColumns: {
        "date": "Fecha",
        "customer": "Cliente",
        "productsSold": "Productos vendidos",
        "products": "Productos",
        "salesAmount": "Monto de ventas",
        "sales": "Ventas",
        "received": "Total Recibido",
        "receivedShort": "Recibido",
        "debited": "Debitado del libro",
        "due": "Adeudado",
        "paymentModes": "Modo(s) de pago",
        "mode": "Modo"
    }
}


export default es
